import { _ as __rest, a as __awaiter } from './tslib.es6-b97b9ccd.js';
import React__default, { useRef, useState, useEffect, useImperativeHandle, useMemo, Fragment, useCallback, forwardRef, memo } from 'react';
import { R as Radio } from './index-ed1b642a.js';
import { Stack, Group, createStyles, getStylesRef, Box } from '@mantine/core';
import '@mantine/dates';
import { L as LOCALE_SPECS, F as FAVICONS } from './index-d722456d.js';
import './index-57001be3.js';
import { C as CommonGAssets } from './index-2bf5f78a.js';
import './useMantineLocale-738fc2b0.js';
import { T as Text } from './index-5c0e8412.js';
import { B as Button$1 } from './index-966f3431.js';
import './index.styles-2ae2bbf8.js';
import './translationsContext-f94ca99c.js';
import '@mantine/hooks';
import { M as MediaQueries } from './utils-1a4cbdae.js';
import './other-cef0261a.js';
import './index-6a7dde31.js';
import { i as isInternalLink } from './index-b131d036.js';
import styled from '@emotion/styled';
import { theme } from './miscTheme.js';
import { C as Checkbox, P as PureInput } from './index-b631b150.js';
import { format, isBefore, startOfMonth, addMonths, subMonths, getDaysInMonth, isToday, isSameDay, isWithinInterval, isAfter, isPast } from 'date-fns';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { L as Logo } from './index-c14e1320.js';
import throttle from 'lodash/throttle';
import parse from 'html-react-parser';
import { domainLocales } from './constantsDomainLocales.js';
import { isProduction } from './constantsIsProduction.js';
import { a as useOutsideClick } from './useOutsideClick-4b5e00d9.js';
import enUS from 'date-fns/locale/en-US';
import id from 'date-fns/locale/id';
import vi from 'date-fns/locale/vi';
import zhTW from 'date-fns/locale/zh-TW';
import { B as Button } from './index-f9473851.js';
import { u as useScreenSize } from './useScreenSize-e572cdeb.js';
import { u as useTranslations } from './index-f8dbf8e4.js';
import { D as Dropdown } from './index-1850d594.js';
import { getSocialList } from './miscGetSocialList.js';
import { I as Input } from './index-0056050c.js';
import { D as Drawer } from './index-1d1c153c.js';
import { v4 } from 'uuid';
import { L as LOCALE } from './Locale-e37edea6.js';
import { ArrowRight } from '@hhgtech/icons/arrow';
import { MultiStar, Question } from '@hhgtech/icons/other';
import Lottie from 'lottie-light-react';

const StyledCategoryCard = styled.a `
  display: flex;
  height: 125px;

  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  padding: 8px;

  border: 1px solid ${theme.colors.neutral100};
  background-color: white;
  border-radius: ${theme.borderRadius};
  box-shadow: 0px 5px 12px rgba(40, 74, 117, 0.08);
  cursor: pointer;
  text-decoration: none;

  & > .banner {
    width: 100%;
    height: 63px;
    text-align: center;
  }

  & > .content {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-align: center;
    word-break: break-word;
  }

  * {
    pointer-events: none;
  }
`;

const CategoryCard = (_a) => {
    var { category, imgBanner, label, className, style, href = '', dataEventCategory, dataEventAction, dataEventLabel } = _a, rest = __rest(_a, ["category", "imgBanner", "label", "className", "style", "href", "dataEventCategory", "dataEventAction", "dataEventLabel"]);
    const url = (category === null || category === void 0 ? void 0 : category.customizedUrl) || (category === null || category === void 0 ? void 0 : category.permalink) || href || '';
    return (React__default.createElement(StyledCategoryCard, Object.assign({ "data-event-category": dataEventCategory, "data-event-action": dataEventAction, "data-event-label": dataEventLabel, className: className, style: style, href: url }, ((category === null || category === void 0 ? void 0 : category.customizedUrl) &&
        !isInternalLink(category.customizedUrl) && {
        target: '_blank',
    }), { onClick: (e) => {
            if (url === '') {
                e.preventDefault();
            }
        } }, rest),
        React__default.createElement("div", { className: "banner" }, imgBanner),
        React__default.createElement("div", { className: "content" },
            React__default.createElement(Text, { className: "category_name", size: "sm", weight: "bold" }, (category === null || category === void 0 ? void 0 : category.displayName) || label || ''))));
};

const StyledCheckboxGroup = styled.div `
  display: flex;

  &[data-type='vertical'] {
    flex-direction: column;

    div {
      margin-bottom: 20px;
    }
  }

  &[data-type='horizontal'] {
    flex-wrap: wrap;

    div {
      margin-right: 25px;
    }

    &[data-is-rectangle] {
      div {
        margin-right: 14px;
      }
    }
  }
`;

const CheckboxGroup = ({ name, values = [], onChanges, options = [], className, type = 'vertical', isDisabled, isRectangle, }) => {
    const onChange = (value, checked) => {
        const newValues = values.slice();
        if (checked) {
            newValues.push(value);
        }
        else {
            const removeIndex = newValues.findIndex((item) => item === value);
            newValues.splice(removeIndex, 1);
        }
        if (onChanges) {
            onChanges(newValues);
        }
    };
    return (React__default.createElement(StyledCheckboxGroup, { className: className, "data-type": type, "data-is-rectangle": isRectangle || undefined }, options.map((option, index) => (React__default.createElement(Checkbox, { label: option.label, name: name, key: `${index}-${option.value}`, checked: values.includes(option.value), value: option.value, isDisabled: isDisabled || option.disabled, onChange: !isDisabled && onChange, isRectangle: isRectangle })))));
};

const MONTHS_TRANSLATION = {
    'vi-VN': [
        'Tháng 1',
        'Tháng 2',
        'Tháng 3',
        'Tháng 4',
        'Tháng 5',
        'Tháng 6',
        'Tháng 7',
        'Tháng 8',
        'Tháng 9',
        'Tháng 10',
        'Tháng 11',
        'Tháng 12',
    ],
    'id-ID': [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
    ],
    'ms-MY': [
        'Januari',
        'Februari',
        'Mac',
        'April',
        'Mei',
        'Jun',
        'Julai',
        'Ogos',
        'September',
        'Oktober',
        'November',
        'Disember',
    ],
    'km-KH': [
        'មករា',
        'ខែកុម្ភៈ',
        'មីនា',
        'ខែមេសា',
        'ឧសភា',
        'មិថុនា',
        'ខែកក្កដា',
        'សីហា',
        'ខែកញ្ញា',
        'តុលា',
        'វិច្ឆិកា',
        'ធ្នូ',
    ],
    'en-PH': [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    'th-TH': [
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'อาจ',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม',
    ],
    'my-MM': [
        'ဇန်နဝါရီလ',
        'ဖေဖော်ဝါရီလ',
        'မတ်လ',
        'ပြီလ',
        'မေလ',
        'ဇွန',
        'ဇူလိုင်လ',
        'သြဂုတ်လ',
        'စက်တင်ဘာ',
        'အောက်တိုဘာ',
        'နိုဝင်ဘာ',
        'ဒီဇင်ဘာ',
    ],
    'zh-TW': [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月',
    ],
    'hi-IN': [
        'जनवरी',
        'फ़रवरी',
        'जुलूस',
        'अप्रैल',
        'मई',
        'जून',
        'जुलाई',
        'अगस्त',
        'सितंबर',
        'अक्टूबर',
        'नवंबर',
        'दिसंबर',
    ],
};

const StyledPickerContainer = styled.div `
  .pickerContainer {
    position: relative;
    padding-top: 0;
    & > div > svg {
      position: absolute;
      top: 36px;
      right: 16px;
      cursor: pointer;
    }

    & > :not(:first-child) {
      position: absolute;
      z-index: 2;
      width: 100%;
    }
  }

  &[data-is-static] .pickerOverlayWrapper {
    position: static;
    max-width: 250px;
    aspect-ratio: 1 / 1;

    > .pickerOverlay {
      padding: 1rem;
    }
  }

  .pickerOverlayWrapper {
    min-width: 320px;
  }

  &[data-align-right='true'] {
    .pickerOverlayWrapper {
      right: 0;
    }
  }

  .pickerOverlay {
    margin-top: 6px;
    background: white;
    border-radius: ${theme.borderRadius};
    box-shadow: 0px 6px 12px rgba(67, 86, 100, 0.2);
  }

  .picker {
    width: 100%;
  }

  .react-datepicker-popper {
    .react-datepicker {
      display: flex;
      width: 340px;
      height: 305px;
      align-items: center;
      justify-content: center;
      border: none;
      box-shadow: (-1px 1px 2px rgba(67, 70, 74, 0.0001)),
        (-2px 2px 5px rgba(67, 86, 100, 0.123689));
    }

    .svg {
      cursor: pointer;
      stroke: ${theme.colors.gray800};
    }
    .react-datepicker__day {
      width: 40px;
    }

    .react-datepicker__header {
      border-bottom: 0;
      background-color: white;
    }

    .react-datepicker__day--outside-month {
      color: #e9e9e9;
    }

    .react-datepicker__day {
      font-weight: ${theme.sizes.fwBold};
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--today,
    .react-datepicker__day--selected:hover,
    .react-datepicker__day--keyboard-selected {
      width: 32px;
      height: 30px;
      margin: 4px;
      margin-bottom: -2px;
      background: ${theme.colors.primaryBase};
      border-radius: 50%;
    }

    .react-datepicker__day-name {
      width: 40px;
    }

    .react-datepicker__triangle {
      display: none;
    }

    .react-datepicker__header.react-datepicker__header--custom {
      svg {
        stroke: #262626;
      }
      select {
        background: ${theme.colors.neutral100};
        text-align: center;
        &:not(:last-child) {
          padding: 8px 10px;
          margin-right: 15px;
          border-radius: ${theme.borderRadius};
        }
      }
    }
  }

  /* DayPicker styles */

  .DayPicker {
    display: inline-block;
    font-size: 1rem;
  }

  .DayPicker-wrapper {
    position: relative;

    flex-direction: row;
    padding-bottom: 1em;

    -webkit-user-select: none;

    -moz-user-select: none;

    -ms-user-select: none;

    user-select: none;
  }

  .DayPicker-Months {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .DayPicker-Month {
    display: table;
    margin: 0 16px;
    margin-top: 16px;
    border-collapse: collapse;
    border-spacing: 0;

    -webkit-user-select: none;

    -moz-user-select: none;

    -ms-user-select: none;

    user-select: none;
  }

  .DayPicker-NavBar {
    position: absolute;
    top: 16px;
    left: 0;
    display: flex;
    width: 100%;
    height: 0;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
  }

  .DayPicker-NavButton {
    width: 24px;
    height: 24px;
    margin-bottom: -47px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 16px 16px;
    color: #8b9898;
    cursor: pointer;
  }

  .DayPicker-NavButton:hover {
    opacity: 0.8;
  }

  .DayPicker-NavButton--prev {
    //left: 2px;
    background-image: url("data:image/svg+xml,%3Csvg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 9L1 5L5 1' stroke='%23262626' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  }

  .DayPicker-NavButton--next {
    //right: 2px;
    background-image: url("data:image/svg+xml,%3Csvg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L1 9' stroke='%23262626' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  }

  .DayPicker-NavButton--interactionDisabled {
    display: none;
  }

  .DayPicker-Caption {
    display: table-caption;
    width: 100%;
    height: 46px;
    padding: 0 32px;
  }

  .DayPicker-Caption select {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
  }

  .DayPicker-Weekdays {
    display: table-header-group;
    margin-top: 1em;
  }

  .DayPicker-WeekdaysRow {
    display: table-row;
  }

  .DayPicker-Weekday {
    display: table-cell;
    padding: 0.5em;
    color: #8b9898;
    font-size: 0.875em;
    text-align: center;
  }

  .DayPicker-Weekday abbr[title] {
    border-bottom: none;
    text-decoration: none;
  }

  .DayPicker-Body {
    display: table-row-group;
  }

  .DayPicker-Week {
    display: table-row;
  }

  .DayPicker-Day {
    display: table-cell;

    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
  }

  .DayPicker-WeekNumber {
    display: table-cell;
    min-width: 1em;
    padding: 0.5em;
    border-right: 1px solid #eaecec;
    color: #8b9898;
    cursor: pointer;
    font-size: 0.75em;
    text-align: right;
    vertical-align: middle;
  }

  .DayPicker--interactionDisabled .DayPicker-Day {
    cursor: default;
  }

  .DayPicker-Footer {
    padding-top: 0.5em;
  }

  .DayPicker-TodayButton {
    border: none;
    background-color: transparent;
    background-image: none;
    box-shadow: none;
    color: #4a90e2;
    cursor: pointer;
    font-size: 0.875em;
  }

  /* Default modifiers */

  .DayPicker-Day--today {
    color: #d0021b;
    font-weight: 700;
  }

  .DayPicker-Day--outside {
    color: #8b9898;
    cursor: default;
  }

  .DayPicker-Day--disabled {
    color: #dce0e0;
    cursor: default;
    /* background-color: #eff1f1; */
  }

  /* Example modifiers */

  .DayPicker-Day--sunday {
    background-color: #f7f8f8;
  }

  .DayPicker-Day--sunday:not(.DayPicker-Day--today) {
    color: #dce0e0;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(
      .DayPicker-Day--outside
    ) {
    position: relative;

    background-color: ${theme.colors.primaryBase};
    color: #f0f8ff;
    font-weight: ${theme.sizes.fwBold};
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(
      .DayPicker-Day--outside
    ):hover {
    background-color: #51a0fa;
  }

  .DayPicker:not(.DayPicker--interactionDisabled)
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(
      .DayPicker-Day--selected
    ):not(.DayPicker-Day--outside):hover {
    background-color: #f0f8ff;
  }

  /* DayPickerInput */

  .DayPickerInput {
    display: inline-block;
  }

  .DayPickerInput-OverlayWrapper {
    position: relative;
  }

  .DayPickerInput-Overlay {
    position: absolute;
    z-index: 1;
    left: 0;

    background: white;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  }
`;
const StyledCaptionWrapper = styled.form `
  display: flex;
  width: 100%;

  height: 46px;
  align-items: center;
  justify-content: space-between;
  & > :first-child {
    margin-right: 10px;
  }

  & * {
    height: 46px;
    padding: 10px 10px;
    background: ${theme.colors.neutral100};
    border-radius: ${theme.borderRadius};
  }
`;

/**
 * @deprecated Consider to use at '@hhgtech/hhg-components/mantine'
 */
const DatePicker = ({ alignRight = true, placeholder, displayDateFormat, onChange, customInput: CustomInput, pickedDate, className, isStatic, disabledDays, modifiers, UnHideOnClickOutside, initialMonth, locale = 'en-PH', }) => {
    const isDatePickerShown = useRef(false);
    const dateFormatter = format;
    const [month, setMonth] = useState(initialMonth || new Date());
    const datePickerContainer = useRef(null);
    const datePicker = useRef(null);
    const defaultDateFormatString = 'yyyy-MM-dd';
    const monthLabels = MONTHS_TRANSLATION[locale];
    const handleDaysSelect = (day) => {
        datePicker.current && !isStatic && datePicker.current.hideDayPicker();
        onChange && onChange(day);
    };
    const handleDayChanged = (selectedDay) => {
        handleDaysSelect(selectedDay);
    };
    const formatPickerDate = (date, format) => {
        return dateFormatter(date, format);
    };
    const handleDateClick = (e) => {
        if (UnHideOnClickOutside)
            return;
        if (!datePickerContainer.current ||
            !datePickerContainer.current.contains(e.target)) {
            datePicker.current && datePicker.current.hideDayPicker();
        }
    };
    // customise the drop downs for Month and year
    const currentYear = new Date().getFullYear();
    const fromMonth = new Date(currentYear - 150, 0);
    const toMonth = new Date(currentYear + 1, 0);
    const YearMonthForm = ({ date, 
    // localeUtils,
    onChange, monthLabels, }) => {
        // const months = localeUtils.getMonths()
        const years = [];
        for (let i = toMonth.getFullYear(); i >= fromMonth.getFullYear(); i -= 1) {
            years.push(i);
        }
        const handleChange = function handleChange(e) {
            const { year, month } = e.target.form;
            onChange(new Date(year.value, month.value));
        };
        return (React__default.createElement("div", { className: "DayPicker-Caption" },
            React__default.createElement(StyledCaptionWrapper, null,
                React__default.createElement("select", { name: "month", onChange: handleChange, value: date.getMonth() }, monthLabels.map((month, i) => (React__default.createElement("option", { key: month, value: i }, month)))),
                React__default.createElement("select", { name: "year", onChange: handleChange, value: date.getFullYear() }, years.map((year) => (React__default.createElement("option", { key: year, value: year }, year)))))));
    };
    const CaptionElement = ({ date, localeUtils, }) => {
        const defaultMonthLabels = localeUtils === null || localeUtils === void 0 ? void 0 : localeUtils.getMonths();
        return (React__default.createElement(YearMonthForm, { date: date, 
            // localeUtils={localeUtils}
            monthLabels: monthLabels || defaultMonthLabels, onChange: setMonth }));
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleDateClick, {
            passive: true,
        });
        return () => {
            document.removeEventListener('mousedown', handleDateClick, false);
        };
    }, []);
    return (React__default.createElement(StyledPickerContainer, { className: className, "data-align-right": alignRight, ref: datePickerContainer, "data-is-static": isStatic || undefined },
        React__default.createElement(DayPickerInput, { ref: datePicker, inputProps: {
                readOnly: true,
            }, keepFocus: false, classNames: {
                container: 'pickerContainer',
                overlayWrapper: 'pickerOverlayWrapper',
                overlay: 'pickerOverlay',
            }, component: CustomInput &&
                React__default.forwardRef(
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                (props, _ref) => (React__default.createElement(CustomInput, Object.assign({}, props)))), onDayPickerHide: () => {
                isDatePickerShown.current = false;
            }, onDayPickerShow: () => {
                isDatePickerShown.current = true;
            }, dayPickerProps: {
                month: month,
                className: 'picker',
                selectedDays: pickedDate,
                canChangeMonth: true,
                enableOutsideDaysClick: isStatic ? false : true,
                firstDayOfWeek: 1,
                captionElement: CaptionElement,
                disabledDays: disabledDays || undefined,
                modifiers: modifiers,
            }, format: displayDateFormat || defaultDateFormatString, formatDate: formatPickerDate, hideOnDayClick: isStatic ? false : true, placeholder: placeholder || '', onDayChange: handleDayChanged, showOverlay: isStatic })));
};

const StyledIconText = styled.div `
  display: flex;
  align-items: center;
  --font-weight-lg: ${theme.sizes.fwBold};
  --font-weight-md: ${theme.sizes.fwRegular};
  --font-weight-sm: ${theme.sizes.fwRegular};

  &[data-icon-position='left'] {
    & > *:first-child {
      margin-right: 8px;
    }

    & > *:last-child {
      width: calc(100% - 24px);
    }
  }
  &[data-icon-position='right'] {
    & > *:first-child {
      width: calc(100% - 24px);
    }
    & > *:last-child {
      margin-left: 8px;
    }
  }

  ${MediaQueries.mbDown} {
    &[data-size='lg'] {
      font-size: 16px;
      line-height: 24px;
      font-weight: var(--font-weight-lg);
    }
    &[data-size='md'] {
      font-size: 14px;
      line-height: 22px;
      font-weight: var(--font-weight-md);
    }
    &[data-size='sm'] {
      font-size: 13px;
      line-height: 20px;
      font-weight: var(----font-weight-sm);
    }
  }
`;

const IconText = ({ size, iconPosition, className, children, icon: Icon, }) => {
    return (React__default.createElement(StyledIconText, { className: className, "data-size": size, "data-icon-position": iconPosition },
        iconPosition === 'left' && Icon,
        children,
        iconPosition === 'right' && Icon));
};

const RadioGroup = React__default.forwardRef(({ id, value, options, className, isDisabled, size: sizeProp = 'small', direction = 'vertical', onChange, dataEventCategory, dataEventAction, dataEventLabel, }, ref) => {
    const [check, setCheck] = useState(value);
    useImperativeHandle(ref, () => ({
        reset() {
            setCheck(value);
        },
    }));
    const handleOnChange = (v) => {
        setCheck(v);
        onChange === null || onChange === void 0 ? void 0 : onChange(v);
    };
    const size = sizeProp === 'small' ? 'md' : 'lg';
    const DirectionComp = direction === 'vertical' ? Stack : Group;
    return (React__default.createElement(Radio.Group, { name: id, className: className, size: size, value: String(check), defaultValue: value, onChange: handleOnChange },
        React__default.createElement(DirectionComp, { spacing: "xl" }, options.map((option) => (React__default.createElement(Radio, { key: option.value, value: option.value, label: option.label, disabled: isDisabled, "data-event-category": dataEventCategory, "data-event-action": dataEventAction, "data-event-label": dataEventLabel }))))));
});

const StyledSideMenu = styled.div `
  --menu-width: 240px;
  --menu-spacing: 28px 16px;
  width: var(--menu-width);
  height: 100vh;
  padding: var(--menu-spacing);
  background-color: ${theme.colors.neutral50};
  transition: ease-in-out 0.5s;

  &[data-is-collapsed] {
    --menu-width: 64px;
    --menu-spacing: 28px 8px;
  }
`;
const SideMenu = ({ isCollapsed, className, style, children }) => {
    return (React__default.createElement(StyledSideMenu, { style: style, className: className, "data-is-collapsed": isCollapsed || undefined }, children));
};

const StyledSideHeader = styled.div `
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  svg {
    transition: 0.4s ease-in-out;
  }
`;
const StyledArrow = styled.div `
  cursor: pointer;
  &[data-is-collapsed] {
    transform: rotate(180deg);
  }
`;
const SideHeader = ({ isCollapsed, defaultLogo, onBackClick, customIcon, }) => {
    return (React__default.createElement(StyledSideHeader, null,
        React__default.createElement(Logo, { type: isCollapsed ? 'logomark' : defaultLogo || 'hellocare', customSize: {
                width: isCollapsed ? '24px' : '77px',
                height: '24px',
            } }),
        React__default.createElement(StyledArrow, { "data-is-collapsed": isCollapsed || undefined, onClick: onBackClick }, customIcon ? (customIcon) : (React__default.createElement("svg", { "data-name": "Layer 1", viewBox: "0 0 20 20", width: "20px", height: "20px" },
            React__default.createElement("path", { d: "M10 .75A9.25 9.25 0 1019.25 10 9.25 9.25 0 0010 .75z", fill: "none", stroke: "#d2d6dc", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5" }),
            React__default.createElement("path", { d: "M11.44 6.53L8 10l3.48 3.47", fill: "none", stroke: "#737373", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5" }))))));
};

const StyledDoctorInfo = styled.figure `
  display: flex;

  > img,
  svg,
  picture {
    width: 40px;
    height: 40px;
    margin-right: 1rem;
    border-radius: 6px;
    object-fit: cover;
  }

  > figcaption {
    p + p {
      margin-top: 2px;
    }
  }
`;
const DoctorInfo = ({ name, description, image, isDescriptionHidden, }) => {
    return (React__default.createElement(StyledDoctorInfo, null,
        image,
        !isDescriptionHidden && (React__default.createElement("figcaption", null,
            React__default.createElement(Text, { size: "p4", weight: "bold" }, name),
            React__default.createElement(Text, { size: "p4" }, description)))));
};

const StyledUserInfo = styled.div `
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 36px;

  figcaption {
    white-space: nowrap;
  }

  &[data-is-collapsed='true'] {
    img {
      max-width: 2rem;
      max-height: 2rem;
    }
  }
`;
const UserInfo = ({ isCollapsed, userName, role, avatar }) => {
    return (React__default.createElement(StyledUserInfo, { "data-is-collapsed": isCollapsed || undefined },
        React__default.createElement(DoctorInfo, { image: avatar, name: userName, description: role, isDescriptionHidden: isCollapsed })));
};

const StyledMenuLink = styled.div `
  display: flex;
  align-items: center;
  padding: 9px 21px;
  margin-bottom: 4px;
  border-radius: 6px;

  &:not([data-is-link-active]) {
    cursor: pointer;
  }

  p {
    margin-left: 12px;
  }

  &[data-is-link-active] {
    background: ${theme.colors.primaryBase};
  }

  &[data-is-link-collapsed] {
    justify-content: center;
    margin-right: -14px;
    margin-left: -14px;
  }
`;
const MenuLink = ({ icon, isActive, children, isCollapsed, activeIcon, onLinkClick, textSize = 'base', textType = 'bold', textColorActive = '#fff', textColor = '#595959', }) => {
    return (React__default.createElement(StyledMenuLink, { "data-is-link-active": isActive || undefined, onClick: onLinkClick, "data-is-link-collapsed": isCollapsed || undefined },
        !(isActive && activeIcon) ? icon : activeIcon,
        !isCollapsed && (React__default.createElement(Text, { size: textSize, weight: textType, color: isActive ? textColorActive : textColor }, children))));
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SideMenu: SideMenu,
  SideHeader: SideHeader,
  UserInfo: UserInfo,
  MenuLink: MenuLink
});

const StyledScrollList = styled.div `
  position: relative;
  width: 100%;
  > .container {
    display: flex;
    width: 100%;
    -ms-overflow-style: none;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .section {
      display: flex;
      width: 100%;
      flex-direction: column;
      flex-shrink: 0;
      margin: auto;

      > .grid-layout {
        display: grid;
        width: 100%;
        grid-row-gap: 8px;

        > .item-grid {
          width: 100%;

          > * {
            margin: 0 auto;
          }
        }
      }

      .progress-bar {
        display: grid;
        height: 15px;
        margin-bottom: 10px;

        .items-progress {
          position: relative;
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: center;

          .icon-status {
            position: absolute;
            display: flex;
          }

          .line {
            width: 50%;
            height: 2px;
            background-color: ${theme.colors.gray600};
          }
        }
      }
    }
  }

  .bullet-nav {
    position: absolute;
    z-index: ${theme.zIndexes.belowHeader};
    bottom: -30px;
    left: 50%;
    display: flex;
    transform: translate(-50%, -50%);
  }

  .bullet-nav__link {
    display: block;
    width: 8px;
    height: 8px;
    padding: 0;
    margin-right: 8px;
    backface-visibility: hidden;
    background-color: #e4e8ec;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s;
    &.active {
      &[data-scheme='hellosites'] {
        background-color: ${theme.colors.primary600};
      }
      &[data-scheme='marrybaby'] {
        background-color: ${theme.mbColors.pink};
      }
    }
  }

  .arrow-left {
    position: absolute;
    z-index: 10;
    top: 50%;
    left: -35px;
    transform: translateY(-50%);
    &[data-event-category] > * {
      pointer-events: none;
    }
  }

  .arrow-right {
    position: absolute;
    z-index: 10;
    top: 50%;
    right: -35px;
    transform: translateY(-50%);
    &[data-event-category] > * {
      pointer-events: none;
    }
  }

  .image-gallery-wrapper {
    display: flex;
    position: relative;
    margin-top: 16px;
    justify-content: center;
    gap: 16px;
    .image-block {
      display: block;
      width: 100%;
      border: 2px solid transparent;
      border-radius: 4px;
    }
    .image-block.active {
      border-color: ${theme.colors.primaryBase};
    }
    img {
      height: 40px;
      width: auto;
      max-width: 100%;
    }
  }
`;

const RenderIconStatus = ({ status }) => {
    if (status === 'inActive') {
        return (React__default.createElement("svg", { width: "6", height: "6", viewBox: "0 0 6 6", fill: "none" },
            React__default.createElement("circle", { cx: "3", cy: "3", r: "3", fill: "#ADB3BC" })));
    }
    else if (status === 'active') {
        return (React__default.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none" },
            React__default.createElement("circle", { cx: "6", cy: "6", r: "4", fill: "#2D87F3" }),
            React__default.createElement("circle", { cx: "6", cy: "6", r: "5.5", stroke: "#2D87F3" })));
    }
    else if (status === 'done') {
        return (React__default.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none" },
            React__default.createElement("path", { d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z", fill: "#00B16A" }),
            React__default.createElement("path", { d: "M8.76061 4.20029L4.80061 7.80029L3.00061 6.16392", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
    }
    return (React__default.createElement("svg", { width: "6", height: "6", viewBox: "0 0 6 6", fill: "none" },
        React__default.createElement("circle", { cx: "3", cy: "3", r: "3", fill: "#ADB3BC" })));
};
/**
 * @deprecated Consider to use at '@hhgtech/hhg-components/mantine'
 */
const ScrollList = ({ row = 2, column = 3, isDotsShown = true, isImageGalleryShown = false, mode = 'infinity', type = 'separated', distanceOverlappedLeft = {
    amount: 0,
    unit: 'pixel',
}, children, className, isProgressShown = false, statusChildren, isArrowShown = false, classNameLeftArrow, classNameRightArrow, dataEventCategory, dataEventAction, dataEventLabel, onChangePage, page, customPageWidth, scheme = 'hellosites', arrowType = 'Discover', }) => {
    const hasPageProps = typeof page === 'number';
    const [section, setSection] = useState(hasPageProps ? page : 0);
    //Create groups
    const groups = [];
    React__default.Children.map(children, (element, idx) => {
        if (idx % (row * column) === 0) {
            groups.push([]);
        }
        groups[groups.length - 1].push(React__default.cloneElement(element));
    });
    const scrollRef = useRef();
    const currentPage = useRef(0);
    const scrollToPage = (index) => {
        if (!scrollRef.current)
            return;
        const { clientWidth } = scrollRef.current;
        const pageWidth = customPageWidth || clientWidth;
        const distance = type === 'intertwined'
            ? distanceOverlappedLeft.unit === 'percentage'
                ? index * pageWidth +
                    (distanceOverlappedLeft.amount / 100) * pageWidth * index
                : index * pageWidth +
                    distanceOverlappedLeft.amount * pageWidth * index
            : index * pageWidth;
        scrollRef.current.scrollTo({
            top: 0,
            left: distance,
            behavior: 'smooth',
        });
        currentPage.current = index;
        setSection(index);
    };
    const handleClick = (index) => {
        if (!scrollRef.current)
            return;
        const { clientWidth } = scrollRef.current;
        const pageWidth = customPageWidth || clientWidth;
        const distance = type === 'intertwined'
            ? distanceOverlappedLeft.unit === 'percentage'
                ? index * pageWidth +
                    (distanceOverlappedLeft.amount / 100) * pageWidth * index
                : index * pageWidth +
                    distanceOverlappedLeft.amount * pageWidth * index
            : index * pageWidth;
        scrollRef.current.scrollTo({
            top: 0,
            left: distance,
            behavior: 'smooth',
        });
        currentPage.current = index;
        setSection(index);
        onChangePage && onChangePage(index);
    };
    useEffect(() => {
        if (typeof page === 'number')
            scrollToPage(page);
    }, [page]);
    const handleClickArrow = (type) => {
        if (!scrollRef.current)
            return;
        const { clientWidth } = scrollRef.current;
        const pageWidth = customPageWidth || clientWidth;
        let distance;
        section === 0 ? (distance = 0) : (distance = section * pageWidth);
        if (type === 'forward') {
            if (distance === pageWidth * (groups.length - 1)) {
                setSection(groups.length - 1);
                distance = pageWidth * (groups.length - 1);
                onChangePage && onChangePage(groups.length - 1);
            }
            else {
                setSection(section + 1);
                distance += pageWidth;
                onChangePage && onChangePage(section + 1);
            }
            scrollRef.current.scrollTo({
                top: 0,
                left: distance,
                behavior: 'smooth',
            });
        }
        if (type === 'back') {
            if (distance === 0) {
                setSection(0);
                onChangePage && onChangePage(0);
                distance = 0;
            }
            else {
                setSection(section - 1);
                onChangePage && onChangePage(section - 1);
                distance -= pageWidth;
            }
            scrollRef.current.scrollTo({
                top: 0,
                left: distance,
                behavior: 'smooth',
            });
        }
    };
    const handleScroll = () => {
        if (mode === 'infinity') {
            if (!scrollRef.current)
                return;
            const { clientWidth, scrollLeft } = scrollRef.current;
            const pageWidth = customPageWidth || clientWidth;
            const page = Math.floor(scrollLeft / pageWidth);
            setSection(page);
            onChangePage && onChangePage(page);
        }
    };
    const handleScrollThrottle = throttle(handleScroll, 400);
    useEffect(() => {
        if (mode === 'snapped') {
            let isDown = false;
            let startX;
            let startY;
            let isSlidingY;
            let isSlidingX;
            let scrollLeft;
            let direction;
            const slider = scrollRef.current;
            const start = (pageX, pageY) => {
                isDown = true;
                isSlidingY = false;
                isSlidingX = false;
                startX = pageX - slider.offsetLeft;
                startY = pageY - slider.offsetTop;
                scrollLeft = slider.scrollLeft;
            };
            const startMouse = (e) => {
                start(e.pageX, e.pageY);
            };
            const startTouch = (e) => {
                start(e.touches[0].pageX, e.touches[0].pageY);
            };
            const end = () => {
                isDown = false;
                isSlidingY = false;
                isSlidingX = false;
                if (!scrollRef.current)
                    return;
                const { clientWidth } = scrollRef.current;
                const pageWidth = customPageWidth || clientWidth;
                const page = direction === 'ltr'
                    ? currentPage.current !== 0
                        ? currentPage.current - 1
                        : currentPage.current
                    : direction === 'rtl'
                        ? currentPage.current < groups.length - 1
                            ? currentPage.current + 1
                            : currentPage.current
                        : currentPage.current;
                const distance = type === 'intertwined'
                    ? distanceOverlappedLeft.unit === 'percentage'
                        ? page * pageWidth +
                            (distanceOverlappedLeft.amount / 100) * pageWidth * page
                        : page * pageWidth +
                            distanceOverlappedLeft.amount * pageWidth * page
                    : page * pageWidth;
                scrollRef.current.scrollTo({
                    top: 0,
                    left: distance,
                    behavior: 'smooth',
                });
                direction = 'none';
                if (currentPage.current !== page) {
                    currentPage.current = page;
                    setSection(page);
                    onChangePage && onChangePage(page);
                }
            };
            const move = (pageX, pageY) => {
                if (!isDown)
                    return;
                const x = pageX - slider.offsetLeft;
                const y = pageY - slider.offsetTop;
                const walkX = x - startX;
                const walkY = y - startY;
                if (!isSlidingY && !isSlidingX && (walkY > 20 || walkY < -20)) {
                    isSlidingY = true;
                }
                if (!isSlidingY && (walkX > 20 || walkX < -20)) {
                    isSlidingX = true;
                    slider.scrollLeft = scrollLeft - walkX;
                    if (walkX > 0) {
                        direction = 'ltr';
                    }
                    if (walkX < 0) {
                        direction = 'rtl';
                    }
                    if (walkX === 0) {
                        direction = 'none';
                    }
                }
            };
            const moveMouse = (e) => {
                if (isSlidingX) {
                    e.preventDefault();
                }
                move(e.pageX, e.pageY);
            };
            const moveTouch = (e) => {
                if (isSlidingX) {
                    e.preventDefault();
                }
                move(e.touches[0].pageX, e.touches[0].pageY);
            };
            slider === null || slider === void 0 ? void 0 : slider.addEventListener('mousedown', startMouse, {
                passive: true,
            });
            slider === null || slider === void 0 ? void 0 : slider.addEventListener('touchstart', startTouch, {
                passive: true,
            });
            window.addEventListener('mouseup', end, {
                passive: true,
            });
            window.addEventListener('touchend', end, {
                passive: true,
            });
            slider === null || slider === void 0 ? void 0 : slider.addEventListener('mousemove', moveMouse, {
                passive: true,
            });
            slider === null || slider === void 0 ? void 0 : slider.addEventListener('touchmove', moveTouch, {
                passive: true,
            });
            return () => {
                slider === null || slider === void 0 ? void 0 : slider.removeEventListener('mousedown', startMouse);
                slider === null || slider === void 0 ? void 0 : slider.removeEventListener('touchstart', startTouch);
                window.removeEventListener('mouseup', end);
                window.removeEventListener('touchend', end);
                slider === null || slider === void 0 ? void 0 : slider.removeEventListener('mousemove', moveMouse);
                slider === null || slider === void 0 ? void 0 : slider.removeEventListener('touchmove', moveTouch);
            };
        }
    }, []);
    return (React__default.createElement(StyledScrollList, { className: className, "data-row": row, onScroll: handleScrollThrottle },
        isArrowShown && section > 0 && (React__default.createElement("div", { className: `${classNameLeftArrow} arrow-left`, onClick: () => handleClickArrow('back'), "data-event-category": dataEventCategory, "data-event-action": dataEventAction, "data-event-label": dataEventLabel }, arrowType === 'Care' ? (React__default.createElement("svg", { width: "42", height: "42", viewBox: "0 0 42 42", fill: "none" },
            React__default.createElement("g", { filter: "url(#filter0_dd_12599_34420)" },
                React__default.createElement("path", { d: "M7.00024 19C7.00024 10.1634 14.1637 3 23.0002 3V3C31.8368 3 39.0002 10.1634 39.0002 19V19C39.0002 27.8366 31.8368 35 23.0002 35V35C14.1637 35 7.00024 27.8366 7.00024 19V19Z", fill: "white" }),
                React__default.createElement("path", { d: "M20.9293 19L24.7503 15.179C25.1643 14.765 25.1643 14.093 24.7503 13.679C24.3363 13.265 23.6643 13.265 23.2503 13.679L18.6363 18.293C18.2453 18.684 18.2453 19.317 18.6363 19.707L23.2503 24.321C23.6643 24.735 24.3363 24.735 24.7503 24.321C25.1643 23.907 25.1643 23.235 24.7503 22.821L20.9293 19Z", fill: "#595959" }),
                React__default.createElement("path", { d: "M23.0002 34C14.716 34 8.00024 27.2843 8.00024 19H6.00024C6.00024 28.3888 13.6114 36 23.0002 36V34ZM38.0002 19C38.0002 27.2843 31.2845 34 23.0002 34V36C32.3891 36 40.0002 28.3888 40.0002 19H38.0002ZM23.0002 4C31.2845 4 38.0002 10.7157 38.0002 19H40.0002C40.0002 9.61116 32.3891 2 23.0002 2V4ZM23.0002 2C13.6114 2 6.00024 9.61116 6.00024 19H8.00024C8.00024 10.7157 14.716 4 23.0002 4V2Z", fill: "#DBDFE5" })),
            React__default.createElement("defs", null,
                React__default.createElement("filter", { id: "filter0_dd_12599_34420", x: "0.000244141", y: "0", width: "42", height: "42", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dx: "-2", dy: "2" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "2.5" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.263201 0 0 0 0 0.335725 0 0 0 0 0.393257 0 0 0 0.123689 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_12599_34420" }),
                    React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                    React__default.createElement("feOffset", { dx: "-1", dy: "1" }),
                    React__default.createElement("feGaussianBlur", { stdDeviation: "1" }),
                    React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.264489 0 0 0 0 0.275745 0 0 0 0 0.28861 0 0 0 0.01 0" }),
                    React__default.createElement("feBlend", { mode: "normal", in2: "effect1_dropShadow_12599_34420", result: "effect2_dropShadow_12599_34420" }),
                    React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_12599_34420", result: "shape" }))))) : (React__default.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none" },
            React__default.createElement("path", { d: "M15.9996 28.2218C22.7497 28.2218 28.2218 22.7497 28.2218 15.9996C28.2218 9.24942 22.7497 3.77734 15.9996 3.77734C9.24942 3.77734 3.77734 9.24942 3.77734 15.9996C3.77734 22.7497 9.24942 28.2218 15.9996 28.2218Z", stroke: scheme === 'hellosites' ? '#2D87F3' : '#e85388', strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M15.9997 11.1109L11.1108 15.9998L15.9997 20.8887", stroke: scheme === 'hellosites' ? '#2D87F3' : '#e85388', strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
            React__default.createElement("path", { d: "M20.8886 15.999L11.1108 15.999", stroke: scheme === 'hellosites' ? '#2D87F3' : '#e85388', strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))))),
        React__default.createElement("div", { ref: scrollRef, className: "container", style: {
                overflowX: mode === 'snapped' || isArrowShown ? 'hidden' : 'scroll',
            } }, groups.map((group, groupIndex) => {
            let baseIndex = 0;
            for (let i = 0; i < groupIndex; i++) {
                baseIndex += groups[i].length;
            }
            return (React__default.createElement("div", { key: groupIndex, className: "section", style: {
                    marginLeft: type === 'intertwined' && groupIndex !== 0
                        ? distanceOverlappedLeft.amount +
                            '' +
                            (distanceOverlappedLeft.unit === 'percentage'
                                ? '%'
                                : 'px')
                        : '0px',
                } },
                row === 1 && isProgressShown && (React__default.createElement("div", { className: "progress-bar", style: {
                        gridTemplateColumns: `repeat(${column}, 1fr)`,
                    } }, group.map((item, itemIndex) => {
                    const realIndex = baseIndex + itemIndex;
                    const foundStatusItem = statusChildren.find((statusItem) => statusItem.index === realIndex);
                    return (React__default.createElement("div", { className: "items-progress", key: itemIndex },
                        itemIndex === 0 && groupIndex === 0 ? (React__default.createElement("div", { className: "line", style: { visibility: 'hidden' } })) : (React__default.createElement("div", { className: "line" })),
                        React__default.createElement("div", { className: "icon-status" },
                            React__default.createElement(RenderIconStatus, { status: foundStatusItem === null || foundStatusItem === void 0 ? void 0 : foundStatusItem.status })),
                        groupIndex === groups.length - 1 &&
                            itemIndex === group.length - 1 ? (React__default.createElement("div", { className: "line", style: { visibility: 'hidden' } })) : (React__default.createElement("div", { className: "line" }))));
                }))),
                React__default.createElement("div", { className: "grid-layout", "data-index": groupIndex, style: {
                        gridTemplateColumns: `repeat(${column}, 1fr)`,
                        gridTemplateRows: `repeat(${row}, 1fr)`,
                    } }, group.map((item, itemIndex) => (React__default.createElement(React__default.Fragment, { key: itemIndex },
                    React__default.createElement("div", { className: "item-grid", key: itemIndex }, item)))))));
        })),
        isArrowShown && section < groups.length - 1 && (React__default.createElement("div", { className: `${classNameRightArrow} arrow-right`, onClick: () => handleClickArrow('forward'), "data-event-category": dataEventCategory, "data-event-action": dataEventAction, "data-event-label": dataEventLabel },
            ' ',
            arrowType === 'Care' ? (React__default.createElement("svg", { width: "42", height: "42", viewBox: "0 0 42 42", fill: "none" },
                React__default.createElement("g", { filter: "url(#filter0_dd_12597_34423)" },
                    React__default.createElement("path", { d: "M7.00024 19C7.00024 10.1634 14.1637 3 23.0002 3C31.8368 3 39.0002 10.1634 39.0002 19C39.0002 27.8366 31.8368 35 23.0002 35C14.1637 35 7.00024 27.8366 7.00024 19Z", fill: "white" }),
                    React__default.createElement("path", { d: "M24.0712 19L20.2502 15.179C19.8362 14.765 19.8362 14.093 20.2502 13.679C20.6642 13.265 21.3362 13.265 21.7502 13.679L26.3642 18.293C26.7552 18.684 26.7552 19.317 26.3642 19.707L21.7502 24.321C21.3362 24.735 20.6642 24.735 20.2502 24.321C19.8362 23.907 19.8362 23.235 20.2502 22.821L24.0712 19Z", fill: "#595959" }),
                    React__default.createElement("path", { d: "M23.0002 34C14.716 34 8.00024 27.2843 8.00024 19H6.00024C6.00024 28.3888 13.6114 36 23.0002 36V34ZM38.0002 19C38.0002 27.2843 31.2845 34 23.0002 34V36C32.3891 36 40.0002 28.3888 40.0002 19H38.0002ZM23.0002 4C31.2845 4 38.0002 10.7157 38.0002 19H40.0002C40.0002 9.61116 32.3891 2 23.0002 2V4ZM23.0002 2C13.6114 2 6.00024 9.61116 6.00024 19H8.00024C8.00024 10.7157 14.716 4 23.0002 4V2Z", fill: "#DBDFE5" })),
                React__default.createElement("defs", null,
                    React__default.createElement("filter", { id: "filter0_dd_12597_34423", x: "0.000244141", y: "0", width: "42", height: "42", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                        React__default.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                        React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                        React__default.createElement("feOffset", { dx: "-2", dy: "2" }),
                        React__default.createElement("feGaussianBlur", { stdDeviation: "2.5" }),
                        React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.263201 0 0 0 0 0.335725 0 0 0 0 0.393257 0 0 0 0.123689 0" }),
                        React__default.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_12597_34423" }),
                        React__default.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                        React__default.createElement("feOffset", { dx: "-1", dy: "1" }),
                        React__default.createElement("feGaussianBlur", { stdDeviation: "1" }),
                        React__default.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.264489 0 0 0 0 0.275745 0 0 0 0 0.28861 0 0 0 0.01 0" }),
                        React__default.createElement("feBlend", { mode: "normal", in2: "effect1_dropShadow_12597_34423", result: "effect2_dropShadow_12597_34423" }),
                        React__default.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_12597_34423", result: "shape" }))))) : (React__default.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none" },
                React__default.createElement("path", { d: "M15.9996 28.2218C22.7497 28.2218 28.2218 22.7497 28.2218 15.9996C28.2218 9.24942 22.7497 3.77734 15.9996 3.77734C9.24942 3.77734 3.77734 9.24942 3.77734 15.9996C3.77734 22.7497 9.24942 28.2218 15.9996 28.2218Z", stroke: scheme === 'hellosites' ? '#2D87F3' : '#e85388', strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M15.9998 20.8891L20.8887 16.0002L15.9998 11.1113", stroke: scheme === 'hellosites' ? '#2D87F3' : '#e85388', strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                React__default.createElement("path", { d: "M11.1109 16L20.8887 16", stroke: scheme === 'hellosites' ? '#2D87F3' : '#e85388', strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))))),
        isDotsShown && (React__default.createElement("ul", { className: "bullet-nav" }, groups.map((group, index) => (React__default.createElement("li", { key: index, className: "bullet-nav__item " },
            React__default.createElement("p", { onClick: () => handleClick(index), className: `bullet-nav__link scroll ${section == index ? 'active' : null}`, "data-scheme": scheme })))))),
        isImageGalleryShown && (React__default.createElement("div", { className: "image-gallery-wrapper", "data-test": groups.length }, groups.slice(0, 3).map((item, itemIndex) => (React__default.createElement("div", { className: `image-block ${section == itemIndex ? 'active' : null}`, key: itemIndex, onClick: () => handleClick(itemIndex), "data-scheme": scheme }, item)))))));
};

const StyledStatisticContainer = styled.div `
  border-radius: ${theme.borderRadius};
  ${(props) => props['data-is-in-card'] &&
    `
  padding: 12px; 
  background-color: ${props['data-card-color']};`}
`;
const StyledDot = styled.div `
  width: 13px;
  height: 13px;
  margin-right: 10px;
  background-color: ${(props) => props['data-color']};
  border-radius: 50%;
`;
const StyledDescriptionWrapper = styled.div `
  display: flex;
  align-items: center;
  color: ${theme.colors.gray800};
  font-size: ${theme.sizes.fsParagraph4};
  font-weight: ${theme.sizes.fwRegular};
`;
const StyledStatisticNumberWrapper = styled.div `
  display: flex;
  align-items: center;
  margin-top: 4px;
  color: ${theme.colors.gray800};
  font-size: ${theme.sizes.fsHeading2};
  font-weight: ${theme.sizes.fwSemiBold};

  & > svg {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }

  &[data-size='small'] {
    margin-left: 23px;
    font-size: ${theme.sizes.fsParagraph4};
    font-weight: ${theme.sizes.fwBold};
  }
`;

const StatisticCard = ({ type, description, value, withIcon, isInACard, cardColor, className, }) => {
    return (React__default.createElement(StyledStatisticContainer, { className: className, "data-size": type, "data-is-in-card": type === 'big' && isInACard, "data-card-color": cardColor },
        React__default.createElement(StyledDescriptionWrapper, null,
            type === 'small' && React__default.createElement(StyledDot, { "data-color": cardColor }),
            description),
        React__default.createElement(StyledStatisticNumberWrapper, { "data-size": type },
            type !== 'small' && withIcon,
            value)));
};

const StyledTable = styled.table `
  width: 100%;
  position: relative;
`;
const Table = ({ children, className, style, horizontalPadding, verticalPadding, }) => {
    return (React__default.createElement(StyledTable, { className: className, style: Object.assign({ '--horizontal-spacing': horizontalPadding || '19px', '--vertical-spacing': verticalPadding || '26px' }, style) }, children));
};

const StyledTableCell = styled.td `
  padding: var(--vertical-spacing) var(--horizontal-spacing);
  vertical-align: middle;

  &[data-text-align='left'] {
    text-align: left;
  }
  &[data-text-align='right'] {
    text-align: right;
  }
  &[data-text-align='center'] {
    text-align: center;
  }
`;
const Cell = ({ children, className, style, textAlign, isTableHead, }) => {
    return (React__default.createElement(StyledTableCell, { className: className, style: style, "data-text-align": textAlign ? textAlign : 'left', as: isTableHead ? 'th' : 'td' }, children));
};

const StyledTableRow = styled.tr `
  border-bottom: 1px solid ${theme.colors.gray100};

  &[data-is-active='true'] {
    background-color: ${theme.colors.gray200};
  }
`;
const Row = ({ children, className, style, isActive, onRowClicked, rowId, }) => {
    return (React__default.createElement(StyledTableRow, { className: className, "data-is-active": isActive, style: style, onClick: () => {
            onRowClicked && onRowClicked(rowId);
        } }, children));
};

const StyledTableHead = styled.thead `
  th {
    padding: var(--vertical-spacing) var(--horizontal-spacing);
    text-align: left;

    color: ${theme.colors.gray500};
    font-weight: ${theme.sizes.fwBold};
  }
  &[data-is-sticky] {
    th {
      position: sticky;
      top: 0;
      background: white;
      border-bottom: 2px solid ${theme.colors.gray200};
    }
  }
`;
const Head = ({ isSticky, children, className, style }) => {
    return (React__default.createElement(StyledTableHead, { className: className, "data-is-sticky": isSticky || undefined, style: style },
        React__default.createElement(Row, null, children)));
};

const StyledTableBody = styled.tbody `
  position: relative;
  &[data-is-striped] {
    > tr:nth-child(odd) {
      background-color: ${theme.colors.neutral50};
    }
  }
  &[data-is-hoverable] {
    > tr:hover {
      background-color: ${theme.colors.neutral100};
    }
  }
`;
const Body = ({ children, className, style, isHoverable, isStriped, }) => {
    return (React__default.createElement(StyledTableBody, { className: className, style: style, "data-is-striped": isStriped || undefined, "data-is-hoverable": isHoverable || undefined }, children));
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Table: Table,
  Cell: Cell,
  Head: Head,
  Row: Row,
  Body: Body
});

var useStyles = createStyles((theme) => {
    const itemLabelRef = getStylesRef('itemLabel');
    return {
        root: {
            display: 'inline-flex',
            maxWidth: '100%',
            borderBottom: `1px solid ${theme.colors.neutral[1]}`,
            '-webkit-overflow-scrolling': 'touch',
            overflowX: 'auto',
            overflowY: 'hidden',
            '-ms-overflow-style': 'none' /* for Internet Explorer, Edge */,
            'scrollbar-width': 'none' /* for Firefox */,
            '&::-webkit-scrollbar': {
                display: 'none',
            },
            columnGap: theme.spacing.lg,
        },
        item: {
            display: 'flex',
            alignItems: 'center',
            paddingBottom: '4px',
            '&:hover': {
                cursor: 'pointer',
            },
            '&.active': {
                color: theme.fn.primaryColor(),
                borderBottom: `3px solid ${theme.fn.primaryColor()}`,
                bottom: '-1px',
                position: 'relative',
                [`& .${itemLabelRef}`]: {},
            },
        },
        itemInner: {
            display: 'flex',
            alignItems: 'center',
        },
        label: {
            ref: itemLabelRef,
        },
        icon: {
            marginRight: theme.spacing.xs,
        },
    };
});

/**
 * @deprecated Consider to use mantine
 */
const Tabs = ({ style, initialTab, tabContent, onChange, className, dataEventCategory, dataEventAction, dataEventLabel, id, styles, }) => {
    const { classes, cx, theme } = useStyles(undefined, { name: 'Tabs', styles });
    const [activeTab, setActiveTab] = useState(initialTab || 0);
    useEffect(() => {
        setActiveTab(initialTab);
    }, [initialTab]);
    return (React__default.createElement("ul", { style: style, className: cx(classes.root, className), role: "tablist", id: id }, tabContent.map((tab, i) => (React__default.createElement("li", { className: `${classes.item} ${activeTab === i ? 'active' : ''} ${tab.className}`, "aria-selected": activeTab === i, role: "tab", onClick: () => {
            setActiveTab(i);
            onChange && onChange(i);
        }, onKeyDown: (e) => {
            if (e.key === 'Enter') {
                setActiveTab(i);
                onChange && onChange(i);
            }
        }, key: i, "data-event-category": tab.dataEventCategory || dataEventCategory, "data-event-action": tab.dataEventAction || dataEventAction, "data-event-label": tab.dataEventLabel || dataEventLabel, tabIndex: 0, "data-testid": tab.dataTestid },
        React__default.createElement("div", { className: classes.itemInner },
            tab.icon && React__default.createElement("div", { className: classes.icon }, tab.icon),
            React__default.createElement(Text, { className: classes.label, size: tab.textSize || 'sm', weight: tab.textType || 'bold', color: activeTab === i
                    ? theme.fn.primaryColor()
                    : tab.textColor || theme.colors.gray[4], dataEventCategory: tab.dataEventCategory, dataEventAction: tab.dataEventAction, dataEventLabel: tab.dataEventLabel }, tab.name)))))));
};

const TRANSITION_TIMING = 200;
const StyledFloatButtonGroup = styled.div ``;
const StyledFloatButtonGroupBackgroundPanel = styled.div `
  width: 100vw;
  height: 100vh;
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: ${theme.colors.white};
  opacity: 0.83;
  transition: display ${TRANSITION_TIMING}ms linear;

  [data-floatmenu-open='true'] & {
    animation: showBackgroundPanel ${TRANSITION_TIMING}ms linear 0s normal
      forwards;
  }

  [data-floatmenu-open='false'] & {
    animation: hideBackgroundPanel ${TRANSITION_TIMING}ms linear 0s normal
      forwards;
  }

  @keyframes showBackgroundPanel {
    0% {
      opacity: 0;
      width: 100vw;
      height: 100vh;
    }
    100% {
      opacity: 0.83;
    }
  }

  @keyframes hideBackgroundPanel {
    0% {
      width: 100vw;
      height: 100vh;
    }
    99% {
      width: 100vw;
      height: 100vh;
    }
    100% {
      opacity: 0;
      width: 0;
      height: 0;
    }
  }
`;
const StyledFloatButtonGroupContent = styled.div `
  position: fixed;
  right: 16px;
  bottom: 40px;
`;
const StyledFloatButtonGroupItemsWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: all ${TRANSITION_TIMING}ms ease-in-out;
  position: fixed;
  bottom: 112px;
  right: 16px;

  // scale
  [data-animation-type='scale'] & {
    transform-origin: 100% 100%;
  }

  [data-animation-type='scale'][data-floatmenu-open='true'] & {
    transform: scale(1);
  }

  [data-animation-type='scale'][data-floatmenu-open='false'] & {
    transform: scale(0);
    bottom: 46px;
    right: 36px;
  }
`;
const StyledFloatButtonGroupToggleIcon = styled.div `
  border-radius: 50%;
  width: 56px;
  height: 56px;
  position: relative;
  cursor: pointer;
  margin-left: auto;
  transition: all 0.1s linear;
  -webkit-tap-highlight-color: transparent;
  [data-site-type='hb'] & {
    background-color: ${theme.colors.primaryBase};
    &:hover {
      background-color: ${theme.colors.primaryHover};
    }
  }
  [data-site-type='mb'] & {
    background-color: #2d87f3;
    &:hover {
      background-color: #2c74df;
    }
  }

  &:before {
    content: '';
    width: 2px;
    height: 20px;
    background-color: ${theme.colors.white};
    border-radius: 2px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:after {
    content: '';
    width: 20px;
    height: 2px;
    background-color: ${theme.colors.white};
    border-radius: 2px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  [data-floatmenu-open='true'] &:before,
  [data-floatmenu-open='true'] &:after {
    animation: toX ${TRANSITION_TIMING}ms linear 0s normal forwards;
  }

  [data-floatmenu-open='false'] &:before,
  [data-floatmenu-open='false'] &:after {
    animation: toPlus ${TRANSITION_TIMING}ms linear 0s normal forwards;
  }

  @keyframes toX {
    0% {
      transform: translate(-50%, -50%) rotateZ(0deg);
    }
    49% {
      transform: translate(-50%, -50%) rotateZ(0deg);
    }
    50% {
      width: 2px;
      height: 2px;
      transform: translate(-50%, -50%) rotateZ(45deg);
    }
    100% {
      transform: translate(-50%, -50%) rotateZ(45deg);
    }
  }

  @keyframes toPlus {
    0% {
      transform: translate(-50%, -50%) rotateZ(45deg);
    }
    49% {
      transform: translate(-50%, -50%) rotateZ(45deg);
    }
    50% {
      width: 2px;
      height: 2px;
      transform: translate(-50%, -50%) rotateZ(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotateZ(0deg);
    }
  }
`;
const StyledFloatButtonGroupButton = styled.div `
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;

  width: fit-content;
  margin-left: auto;

  [data-floatmenu-open='true'] {
    cursor: pointer;
  }
  [data-floatmenu-open='false'] {
    pointer-events: none;
  }

  [data-animation-type='zoom'] &,
  [data-animation-type='slide'] & {
    position: absolute;
    right: 0;
    width: max-content;
  }
  // slide
  [data-animation-type='slide'] & {
    transition: all ${TRANSITION_TIMING}ms ease-in;
  }

  [data-animation-type='slide'][data-floatmenu-open='true'] & {
    animation: showItem ${TRANSITION_TIMING}ms;
  }
  [data-animation-type='slide'][data-floatmenu-open='false'] & {
    bottom: -64px !important;
    animation: hideItemOnZoom ${TRANSITION_TIMING + 50}ms normal forwards;
  }

  // zoom
  [data-animation-type='zoom'][data-floatmenu-open='false'] & {
    animation: hideItemOnZoom ${TRANSITION_TIMING + 50}ms normal forwards;
  }

  @keyframes showItem {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes hideItemOnZoom {
    0% {
      transform: translateX(0);
      opacity: 1;
    }

    99% {
      transform: translateX(0);
      opacity: 0.5;
    }

    100% {
      transform: translateX(calc(100% + 16px));
      opacity: 0;
    }
  }
`;
const StyledFloatButtonGroupButtonLabel = styled.div `
  font-size: 14px;

  // zoom
  [data-animation-type='zoom'] & {
    transition: transform ${TRANSITION_TIMING}ms ease-in-out;
    transform-origin: 100% 0;
  }

  [data-animation-type='zoom'][data-floatmenu-open='true'] & {
    transform: scale(1);
  }

  [data-animation-type='zoom'][data-floatmenu-open='false'] & {
    transform: scale(0);
  }

  // slide
  [data-animation-type='slide'] & {
    transition: opacity ${TRANSITION_TIMING}ms;
  }
  [data-animation-type='slide'][data-floatmenu-open='true'] & {
    opacity: 1;
  }
  [data-animation-type='slide'][data-floatmenu-open='false'] & {
    opacity: 0;
  }
`;
const StyledFloatButtonGroupButtonIcon = styled.div `
  border-radius: 50%;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 8px rgba(0, 0, 0, 0.04),
    0px 0px 1px rgba(0, 0, 0, 0.04);
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.white};

  // zoom
  [data-animation-type='zoom'] & {
    transition: transform ${TRANSITION_TIMING}ms ease-in-out;
  }

  [data-animation-type='zoom'][data-floatmenu-open='true'] & {
    transform: scale(1);
  }

  [data-animation-type='zoom'][data-floatmenu-open='false'] & {
    transform: scale(0);
  }

  > img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

const FloatButtonGroup = ({ items, className, style, backgroundPanelStyle, isOpen: isOpenProp, onOpen, onClose, disableBackdropClick, siteType = 'hb', animationType = 'zoom', zIndex = 300, }) => {
    const [isOpen, setIsOpen] = useState(!!isOpenProp);
    useEffect(() => {
        setIsOpen(!!isOpenProp);
    }, [isOpenProp]);
    const handleOpen = () => {
        setIsOpen(true);
        if (onOpen) {
            onOpen();
        }
    };
    const handleClose = () => {
        setIsOpen(false);
        if (onClose) {
            onClose();
        }
    };
    return (React__default.createElement(StyledFloatButtonGroup, { style: style, className: className, "data-floatmenu-open": isOpen, "data-site-type": siteType, "data-animation-type": animationType },
        React__default.createElement(StyledFloatButtonGroupBackgroundPanel, { className: "float-button-group__panel", style: Object.assign({ zIndex }, backgroundPanelStyle), onClick: !disableBackdropClick ? handleClose : undefined }),
        React__default.createElement(StyledFloatButtonGroupContent, { className: "float-button-group___content", style: { zIndex } },
            React__default.createElement(StyledFloatButtonGroupItemsWrapper, null, items.map((item, index) => {
                return (React__default.createElement(StyledFloatButtonGroupButton, { className: `float-item-button-${index}`, style: Object.assign(Object.assign({}, (animationType === 'zoom' && {
                        bottom: (items.length - 1 - index) * (48 + 16),
                        transitionDelay: `${(TRANSITION_TIMING / items.length) *
                            (isOpen ? items.length - 1 - index : index)}ms`,
                    })), (animationType === 'slide' && {
                        bottom: (items.length - 1 - index) * (48 + 16),
                        transitionDelay: `${(TRANSITION_TIMING / items.length) *
                            (!isOpen ? items.length - 1 - index : index)}ms`,
                    })), key: index, onClick: () => {
                        item.onClick();
                        if (!item.keepMenuOnClick) {
                            setIsOpen(false);
                        }
                    } },
                    React__default.createElement(StyledFloatButtonGroupButtonLabel, { style: Object.assign({}, (animationType === 'zoom' && {
                            transitionDelay: `${(TRANSITION_TIMING / items.length) *
                                (isOpen ? items.length - 1 - index : index)}ms`,
                        })) }, item.label),
                    React__default.createElement(StyledFloatButtonGroupButtonIcon, { className: "float-item-button__icon-wrapper", style: Object.assign({}, ((animationType === 'zoom' ||
                            animationType === 'slide') && {
                            transitionDelay: `${(TRANSITION_TIMING / items.length) *
                                (isOpen ? items.length - 1 - index : index)}ms`,
                        })) }, item.icon)));
            })),
            React__default.createElement(StyledFloatButtonGroupToggleIcon, { onClick: isOpen ? handleClose : handleOpen }))));
};

const StyledAcceptCardContainer = styled.div `
  padding: 16px;
  width: 375px;
  word-wrap: break-word;
  word-break: break-word;
  ${MediaQueries.mbDown} {
    width: 100%;
  }
  &[data-theme='helloSites'] {
    background: ${theme.colors.secondaryBase};
    box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.1);
  }
  &[data-theme='marryBaby'] {
    border: none;
    background: ${theme.mbColors.pink};
    border-radius: 12px 12px 0 0;
  }
  &[data-is-open='false'] {
    display: none;
  }
  &[data-default-position='true'] {
    position: fixed;
    z-index: 1000;
    bottom: 0;
    right: 0;
    ${MediaQueries.mbDown} {
      left: 0;
      right: unset;
    }
  }
`;
const StyledTitleSection = styled.p `
  position: relative;
  padding-left: 24px;
  color: ${theme.colors.white};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  &[data-has-content='true'] {
    ::before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 16px;
      height: 16px;
      margin: auto 0;
      content: url("data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.00001 1.33331C4.32001 1.33331 1.33334 4.31998 1.33334 7.99998C1.33334 11.68 4.32001 14.6666 8.00001 14.6666C11.68 14.6666 14.6667 11.68 14.6667 7.99998C14.6667 4.31998 11.68 1.33331 8.00001 1.33331ZM8.00001 11.3333C7.63334 11.3333 7.33334 11.0333 7.33334 10.6666V7.99998C7.33334 7.63331 7.63334 7.33331 8.00001 7.33331C8.36668 7.33331 8.66668 7.63331 8.66668 7.99998V10.6666C8.66668 11.0333 8.36668 11.3333 8.00001 11.3333ZM7.33334 5.99998H8.66668V4.66665H7.33334V5.99998Z' fill='white'/%3e%3c/svg%3e");
    }
  }
`;
const StyledDescription = styled.p `
  margin-top: 2px;
  color: ${theme.colors.white};
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  a {
    color: ${theme.colors.white};
    text-decoration: none;
    text-decoration-line: underline;
  }
`;
const StyledButtonGroup = styled.div `
  display: flex;
  align-items: center;
  margin-top: 8px;
  gap: 16px;
`;
const StyledAcceptButton = styled.div `
  padding: 7px 28px;
  background: ${theme.colors.white};
  border-radius: ${theme.borderRadius};
  color: ${theme.colors.secondaryBase};
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
`;
const StyledPoliciesButton = styled.a `
  color: ${theme.colors.white};
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
  text-decoration: none;
  text-decoration-line: underline;
`;

const CookieAcceptConfirm = ({ className, policiesUrl, onAcceptClick, translations = {
    acceptButton: 'Accept',
    policiesButton: 'Our Policies',
}, title = '', description = '', theme = 'helloSites', isOpen = true, useDefaultPosition = true, trackingAttributes, }) => {
    return (React__default.createElement(StyledAcceptCardContainer, { className: className, "data-theme": theme, "data-is-open": isOpen, "data-default-position": useDefaultPosition },
        React__default.createElement(StyledTitleSection, { "data-has-content": !!title }, title),
        React__default.createElement(StyledDescription, { dangerouslySetInnerHTML: {
                __html: description,
            } }),
        React__default.createElement(StyledButtonGroup, null,
            React__default.createElement(StyledAcceptButton, { role: "button", tabIndex: 0, onClick: onAcceptClick, "data-event-category": trackingAttributes === null || trackingAttributes === void 0 ? void 0 : trackingAttributes.dataEventCategory, "data-event-action": trackingAttributes === null || trackingAttributes === void 0 ? void 0 : trackingAttributes.dataEventAction, "data-event-label": trackingAttributes === null || trackingAttributes === void 0 ? void 0 : trackingAttributes.dataEventLabel }, translations.acceptButton),
            React__default.createElement(StyledPoliciesButton, { href: policiesUrl }, translations.policiesButton))));
};

const SeoHead = ({ SEOData = {}, locale = 'vi-VN', routerPathname: pathname, routerQuery: query, nextHead: Head, siteType, seoCustom, userId, forcedCanonicalUrl, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const { totalPages, currentPage, SEOTitle = '', SEODescription = '', SEOImage, seoType, SEOImageWidth, SEOImageHeight, customMetaData = [], isIndexable = true, hasNoCanonical = false, } = SEOData;
    const robotIndex = isIndexable && isProduction
        ? 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1'
        : 'noindex';
    // const { locale = 'vi-VN', pathname, query } = router
    const { NEXT_PUBLIC_BASE_API_URL } = process.env;
    let newPath = SEOData.canonicalUrl || pathname;
    Object.keys(query).forEach((key) => {
        const queryItem = query[key];
        if (queryItem && Array.isArray(queryItem)) {
            newPath = newPath.replace(`[...${key}]`, queryItem.join('/'));
        }
    });
    const sL = locale || 'en-PH'; // standardized locale
    const siteUrl = siteType === 'helloSites' ? domainLocales[sL] : 'www.marrybaby.vn';
    const hasSlash = newPath.endsWith('/') ? '' : '/';
    // TODO: remove or replace html-react-parser
    const metaData = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        let resMetaData = '';
        if (SEOData.apiMetaData && typeof SEOData.apiMetaData === 'string') {
            const paginatedTitle = (_a = SEOData.apiMetaData) === null || _a === void 0 ? void 0 : _a.match(/<title.*?>(.*)<\/title>/);
            const paginatedNumber = ` - Page ${currentPage} of ${totalPages}`;
            const fD = currentPage && currentPage !== 1 && paginatedTitle
                ? SEOData.apiMetaData
                    .replace(paginatedTitle[0], paginatedTitle[0].includes('-')
                    ? paginatedTitle[0].replace('-', paginatedNumber + ' - ')
                    : `<title>${paginatedTitle[1].concat(paginatedNumber)}</title>`)
                    .replace(`<link rel="canonical" href="https://${siteUrl}${newPath}${hasSlash}" />`, `<link rel="canonical" href="https://${siteUrl}${newPath}${hasSlash}?page=${currentPage}" />`)
                : SEOData.apiMetaData;
            resMetaData = parse(fD, { trim: true });
            if (!resMetaData.find((data) => {
                var _a, _b;
                return ((_a = data.props) === null || _a === void 0 ? void 0 : _a.property) === 'og:image' ||
                    ((_b = data.props) === null || _b === void 0 ? void 0 : _b.property) === 'og:image:secure_url';
            })) {
                const DefaultOgImage = `https://${siteUrl}/images/${locale}.png`;
                resMetaData = [
                    ...resMetaData,
                    React__default.createElement("meta", { key: 'og:image', property: "og:image", content: ((_b = SEOData.openGraph) === null || _b === void 0 ? void 0 : _b.image) || SEOImage || DefaultOgImage || '' }),
                    React__default.createElement("meta", { key: 'og:image:secure_url', property: "og:image:secure_url", content: ((_c = SEOData.openGraph) === null || _c === void 0 ? void 0 : _c.image) || SEOImage || DefaultOgImage }),
                    React__default.createElement("meta", { key: 'og:image:width', property: "og:image:width", content: (((_d = SEOData.openGraph) === null || _d === void 0 ? void 0 : _d.imageWidth) &&
                            String((_e = SEOData.openGraph) === null || _e === void 0 ? void 0 : _e.imageWidth)) ||
                            (SEOImageWidth && String(SEOImageWidth)) ||
                            '1200' }),
                    React__default.createElement("meta", { key: 'og:image:height', property: "og:image:height", content: (((_f = SEOData.openGraph) === null || _f === void 0 ? void 0 : _f.imageHeight) &&
                            String((_g = SEOData.openGraph) === null || _g === void 0 ? void 0 : _g.imageHeight)) ||
                            (SEOImageHeight && String(SEOImageHeight)) ||
                            '630' }),
                ];
            }
        }
        return resMetaData;
    }, [
        SEOData.apiMetaData,
        SEOData.openGraph,
        SEOImage,
        SEOImageHeight,
        SEOImageWidth,
        currentPage,
        newPath,
        totalPages,
        locale,
        siteUrl,
    ]);
    const defaultImage = `https://${siteUrl}/images/${locale}.png`;
    const fontUrl = siteType === 'marryBaby'
        ? 'https://fonts.googleapis.com/css2?family=Inter:wght@400..800&display=swap'
        : locale === 'km-KH'
            ? 'https://fonts.googleapis.com/css2?family=Battambang:wght@400;700&display=swap'
            : locale === 'th-TH'
                ? 'https://fonts.googleapis.com/css2?family=Noto+Sans+Thai:wdth,wght@62.5..100,100..900&display=swap'
                : 'https://fonts.googleapis.com/css2?family=Inter:wght@400..800&display=swap';
    return (React__default.createElement(Head, null,
        React__default.createElement("link", { rel: "preconnect", href: "https://fonts.gstatic.com" }),
        React__default.createElement("link", { rel: "preload", href: fontUrl, as: "style" }),
        React__default.createElement("link", { rel: "stylesheet", href: fontUrl }),
        React__default.createElement("link", { rel: "preconnect", href: NEXT_PUBLIC_BASE_API_URL }),
        React__default.createElement("meta", { charSet: "UTF-8" }),
        React__default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover" }),
        React__default.createElement("meta", { name: "google", content: "notranslate" }),
        React__default.createElement("meta", { name: "robots", content: robotIndex }),
        React__default.createElement("meta", { property: "fb:app_id", content: "653713035016537" }),
        customMetaData.map((customMeta, index) => {
            return React__default.createElement("meta", Object.assign({ key: index }, customMeta));
        }),
        React__default.createElement("meta", { name: "theme-color", content: siteType === 'helloSites' ? '#2c87f3' : '#e85388' }),
        React__default.createElement("meta", { name: "page_type", content: "Home" }),
        React__default.createElement("meta", { name: "page_platform", content: "WEB" }),
        React__default.createElement("meta", { name: "page_language", content: sL }),
        React__default.createElement("meta", { name: "ahrefs-site-verification", content: "46e7521a2b89a1013149c4685bbe02a1d36a4732fef98655142b829bc87cba4d" }),
        !metaData && (React__default.createElement(React__default.Fragment, null,
            siteType === 'helloSites' ? (React__default.createElement("title", null, seoCustom
                ? SEOTitle
                : SEOTitle + ' - ' + ((_a = LOCALE_SPECS[locale]) === null || _a === void 0 ? void 0 : _a.SITE_NAME))) : (React__default.createElement("title", null, SEOTitle)),
            !hasNoCanonical && (React__default.createElement("link", { rel: "canonical", href: `https://${siteUrl}${newPath}` })),
            React__default.createElement("meta", { name: "description", content: SEODescription || ((_b = SEOData.openGraph) === null || _b === void 0 ? void 0 : _b.description) }),
            SEOData.schemaData && (React__default.createElement("script", { type: "application/ld+json", className: "yoast-schema-graph", dangerouslySetInnerHTML: { __html: SEOData.schemaData } })),
            React__default.createElement("meta", { property: "og:locale", content: locale }),
            React__default.createElement("meta", { property: "og:type", content: seoType || 'website' }),
            React__default.createElement("meta", { property: "og:title", content: ((_c = SEOData.openGraph) === null || _c === void 0 ? void 0 : _c.title) || SEOTitle }),
            React__default.createElement("meta", { property: "og:description", content: ((_d = SEOData.openGraph) === null || _d === void 0 ? void 0 : _d.description) || SEODescription }),
            React__default.createElement("meta", { property: "og:url", content: `https://${siteUrl}${newPath}` }),
            React__default.createElement("meta", { property: "og:site_name", content: `https://${siteUrl}` }),
            React__default.createElement("meta", { property: "og:image", content: ((_e = SEOData.openGraph) === null || _e === void 0 ? void 0 : _e.image) || SEOImage || defaultImage || '' }),
            React__default.createElement("meta", { property: "og:image:secure_url", content: ((_f = SEOData.openGraph) === null || _f === void 0 ? void 0 : _f.image) || SEOImage || defaultImage }),
            React__default.createElement("meta", { property: "og:image:width", content: (((_g = SEOData.openGraph) === null || _g === void 0 ? void 0 : _g.imageWidth) &&
                    String((_h = SEOData.openGraph) === null || _h === void 0 ? void 0 : _h.imageWidth)) ||
                    (SEOImageWidth && String(SEOImageWidth)) ||
                    '1200' }),
            React__default.createElement("meta", { property: "og:image:height", content: (((_j = SEOData.openGraph) === null || _j === void 0 ? void 0 : _j.imageHeight) &&
                    String((_k = SEOData.openGraph) === null || _k === void 0 ? void 0 : _k.imageHeight)) ||
                    (SEOImageHeight && String(SEOImageHeight)) ||
                    '630' }),
            React__default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
            React__default.createElement("meta", { name: "twitter:title", content: ((_l = SEOData.twitter) === null || _l === void 0 ? void 0 : _l.title) || SEOTitle }),
            React__default.createElement("meta", { name: "twitter:description", content: SEODescription }),
            React__default.createElement("meta", { name: "twitter:image", content: ((_m = SEOData.twitter) === null || _m === void 0 ? void 0 : _m.image) || SEOImage }))),
        (siteType === 'helloSites'
            ? FAVICONS[sL] || []
            : FAVICONS.marryBaby).map((item, index) => {
            if (item.type === 'link') {
                return (React__default.createElement("link", { key: `favicon-${index}`, rel: item.rel, href: item.href, sizes: item.sizes }));
            }
            if (item.type === 'meta') {
                return React__default.createElement("meta", { key: index, name: item.name, content: item.content });
            }
            return null;
        }),
        Array.isArray(metaData) && !!forcedCanonicalUrl
            ? metaData.filter((d) => d.props.name !== 'canonical' && d.props.rel !== 'canonical')
            : metaData,
        forcedCanonicalUrl && React__default.createElement("link", { rel: "canonical", href: forcedCanonicalUrl }),
        !SEOData.hasNoAmp && locale !== 'vi-VN' && (React__default.createElement("link", { rel: "amphtml", href: `https://${siteUrl}${newPath}${hasSlash}?amp=1` })),
        userId && typeof window !== 'undefined' ? (React__default.createElement("script", { dangerouslySetInnerHTML: {
                __html: `window.dataLayer = window.dataLayer || []; window.dataLayer.push({'userID': '${userId}'});`,
            } })) : null));
};

const StyledCalendarWrapper$1 = styled.div `
  flex: 1;
`;
const StyledCalendarCellsWrapper = styled.div `
  padding: 0 10px;
`;
const StyledCalendarHead = styled.div `
  display: flex;
  height: 80px;
  align-items: center;
  .calendar-month {
    font-size: 16px;
    flex: 1;
    text-align: center;
    strong {
      margin-left: 5px;
    }
  }
  ${MediaQueries.mbDown} {
    height: 70px;
  }
`;
const StyledCalendarGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  row-gap: 2px;
`;
const StyledCalendarDaysOfWeek = styled(StyledCalendarGrid) `
  margin-bottom: 8px;
`;
styled.div `
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledCalendarDayLabel = styled.div `
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: 1px solid ${theme.colors.gray800};
  font-weight: 300;
`;
const StyledCalendarMonthSeparator = styled.div `
  width: 18px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    inset: 16px 0 0 0;
    width: 1px;
    left: 50%;
    right: 50%;
    background: ${theme.colors.neutral100};
  }
`;
const StyledCalendarDaysWrapper = styled.div `
  margin: 0 auto;
`;
const StyledCalendarMonthWrapper = styled.div `
  position: relative;
`;
const StyledCalendarDateGrid = StyledCalendarGrid;
const StyledCalendarDayNumberWrapper = styled.div `
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  ${MediaQueries.mbUp} {
    height: 38px;
  }
  &[data-is-disabled='true'] {
    opacity: 0.3;
  }
  &[data-in-range='true']:not([data-is-from='true'][data-is-to='true']) {
    background-color: ${theme.colors.gray100};
  }
  &:before {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: ${theme.colors.gray100};
  }
  &[data-is-from='true'][data-in-range='true'][data-is-to='false'] {
    background-color: transparent;
    &:before {
      content: '';
      left: 50%;
      right: 0;
    }
  }

  &[data-is-to='true'][data-in-range='true'][data-is-from='false'],
  &:hover[data-in-range='true']:is([data-has-range='false'] &) {
    background-color: transparent;
    &:before {
      content: '';
      left: 0;
      right: 50%;
    }
  }
`;
const StyledCalendarDayNumber = styled.div `
  position: relative;
  font-weight: 600;
  ${MediaQueries.mbDown} {
    width: 32px;
    height: 32px;
  }
  ${MediaQueries.mbUp} {
    width: 36px;
    height: 36px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  [data-is-disabled='true'] & {
    cursor: not-allowed;
  }
  line-height: 1;
  color: 1px solid ${theme.colors.gray800};
  [data-is-selected='true'] &,
  [data-is-today='true'] &,
  [data-is-selected='false']:hover & {
    border-radius: 32px;
  }
  [data-is-selected='true'] & {
    background-color: ${theme.colors.primaryBase};
    color: white;
  }
  [data-is-selected='false']:hover & {
    background-color: ${theme.colors.primary50};
  }
  [data-is-today='true'][data-is-selected='false'] & {
    background-color: transparent;
    border-radius: 32px;
    border: 1px solid ${theme.colors.primaryBase};
  }
`;

function handleClickDay(d, range) {
    if (!range.from && !range.to) {
        return Object.assign(Object.assign({}, range), { from: d });
    }
    if (range.from && range.to) {
        return { from: d, to: null };
    }
    if (range.from) {
        if (isBefore(d, range.from)) {
            return Object.assign(Object.assign({}, range), { from: d });
        }
        else {
            return Object.assign(Object.assign({}, range), { to: d });
        }
    }
    return range;
}

const dateLocaleByLocale = {
    'en-PH': enUS,
    'vi-VN': vi,
    'zh-TW': zhTW,
    'id-ID': id,
};
function DateRangePickerCalendar(props) {
    const { value = { from: null, to: null } } = props;
    const [hoverDay, setHoverDay] = useState(null);
    const { isMobile } = useScreenSize();
    const [range, setRange] = useState(() => value);
    const [date, setDate] = useState(() => { var _a; return startOfMonth((_a = value.from) !== null && _a !== void 0 ? _a : new Date()); });
    const nextMonth = useMemo(() => addMonths(date, 1), [date]);
    function goToPreviousMonth() {
        setDate((d) => subMonths(d, 1));
    }
    function goToNextMonth() {
        setDate((d) => addMonths(d, 1));
    }
    const monthProps = Object.assign(Object.assign({}, props), { goToNextMonth,
        goToPreviousMonth,
        range,
        setRange,
        hoverDay,
        setHoverDay });
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(DateRangePickerCalendarMonth, Object.assign({}, monthProps, { date: date })),
        !isMobile && React__default.createElement(StyledCalendarMonthSeparator, null),
        !isMobile && (React__default.createElement(DateRangePickerCalendarMonth, Object.assign({}, monthProps, { date: nextMonth })))));
}
function DateRangePickerCalendarMonth({ date, 
// value,
range, setRange, onChange, goToPreviousMonth, goToNextMonth, minDate, maxDate, close = () => undefined, autoClose = false, hoverDay, setHoverDay, }) {
    const { locale } = useTranslations();
    const dateLocale = useMemo(() => { var _a; return (_a = dateLocaleByLocale[locale]) !== null && _a !== void 0 ? _a : dateLocaleByLocale['en-PH']; }, [locale]);
    const monthLabel = useMemo(() => format(date, 'MMMM', { locale: dateLocale }), [date, dateLocale]);
    const weekDays = useMemo(() => {
        if (!dateLocale) {
            return [];
        }
        return [1, 2, 3, 4, 5, 6, 0].map((i) => dateLocale.localize.day(i, { width: 'narrow' }));
    }, [dateLocale]);
    useEffect(() => {
        if (range.from && range.to) {
            onChange(range);
        }
    }, [range]);
    function renderWeekDays() {
        return (React__default.createElement(StyledCalendarDaysOfWeek, null, weekDays.map((d, i) => (React__default.createElement(StyledCalendarDayLabel, { key: `${d}-${i}` }, d)))));
    }
    function renderMonth() {
        const year = date.getFullYear();
        const monthIndex = date.getMonth();
        const daysInMonth = getDaysInMonth(date);
        const days = [];
        for (let i = 1; i <= daysInMonth; i++) {
            days.push(new Date(year, monthIndex, i));
        }
        const weekDayIndex = days[0] ? days[0].getDay() : 0;
        if (weekDayIndex !== 1) {
            const idx = weekDayIndex === 0 ? 6 : weekDayIndex - 1;
            for (let i = 0; i < idx; i++) {
                days.unshift(null);
            }
        }
        return (React__default.createElement(StyledCalendarMonthWrapper, { key: `month-${monthIndex}`, "data-month-index": monthIndex, "data-has-range": Boolean(range.from && range.to) },
            React__default.createElement(StyledCalendarDaysWrapper, null,
                React__default.createElement(StyledCalendarDateGrid, null, days.map(renderDay)))));
    }
    function renderDay(d, index) {
        if (d === null) {
            return (React__default.createElement(StyledCalendarDayNumberWrapper, { key: `idx-${index}`, "data-empty": "true" }));
        }
        const day = d.getDate();
        const isDateToday = isToday(d);
        const isFrom = range.from ? isSameDay(range.from, d) : false;
        const isTo = range.to ? isSameDay(range.to, d) : false;
        const isSelected = isFrom || isTo;
        const hasHoveredDay = hoverDay !== null;
        let inRange = false;
        if (hasHoveredDay &&
            range.from &&
            isBefore(range.from, hoverDay) &&
            !range.to) {
            inRange = isWithinInterval(d, { start: range.from, end: hoverDay });
        }
        else if (range.from && range.to) {
            inRange = isWithinInterval(d, { start: range.from, end: range.to });
        }
        let isDisabled = false;
        if (minDate && maxDate) {
            isDisabled = !isWithinInterval(d, { start: minDate, end: maxDate });
        }
        else if (minDate) {
            isDisabled = isBefore(d, minDate);
        }
        else if (maxDate) {
            isDisabled = isAfter(d, maxDate);
        }
        return (React__default.createElement(StyledCalendarDayNumberWrapper, { key: day, "data-is-today": isDateToday, "data-is-past": !isDateToday && isPast(d), "data-is-selected": isSelected, "data-is-disabled": isDisabled, "data-in-range": inRange, "data-is-from": isFrom, "data-is-to": isTo, onMouseEnter: () => {
                setHoverDay(d);
            }, onMouseLeave: () => setHoverDay(null), onClick: () => {
                if (isDisabled) {
                    return;
                }
                setRange((r) => {
                    if (autoClose && range.from && !range.to) {
                        close();
                    }
                    return handleClickDay(d, r);
                });
            } },
            React__default.createElement(StyledCalendarDayNumber, { onClick: () => undefined },
                React__default.createElement("p", null, day))));
    }
    return (React__default.createElement(StyledCalendarWrapper$1, { className: "calendar-wrapper" },
        React__default.createElement(StyledCalendarHead, null,
            React__default.createElement(Button, { onClick: goToPreviousMonth, size: "md", color: "ghost", icon: React__default.createElement("img", { src: CommonGAssets.getAssetPath('calendarArrowLeft.svg'), loading: "lazy" }) }),
            React__default.createElement("div", { className: "calendar-month" },
                monthLabel,
                React__default.createElement("strong", null, format(date, 'yyyy'))),
            React__default.createElement(Button, { onClick: goToNextMonth, size: "md", color: "ghost", icon: React__default.createElement("img", { src: CommonGAssets.getAssetPath('calendarArrowRight.svg'), loading: "lazy" }) })),
        React__default.createElement(StyledCalendarCellsWrapper, null,
            React__default.createElement("div", null, renderWeekDays()),
            React__default.createElement("div", null, renderMonth()))));
}

const StyledWrapper = styled.div `
  display: block;
  position: relative;
  width: 270px;
  input {
    pointer-events: none;
    caret-color: transparent;
  }
  ${MediaQueries.mbDown} {
    width: 100%;
  }
`;
const StyledCalendarWrapper = styled.div `
  display: flex;
  position: absolute;
  top: 46px;
  left: 0;
  width: 684px;
  border: 1px solid ${theme.colors.gray200};
  filter: drop-shadow(0px 10px 16px rgba(0, 0, 0, 0.04))
    drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.04))
    drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.04));
  border-radius: ${theme.borderRadius};
  background-color: white;
  z-index: 100;
  padding-bottom: 16px;
  align-items: stretch;
  user-select: none;
  ${MediaQueries.mbDown} {
    width: 100%;
  }
`;

/**
 * @deprecated Consider to use at '@hhgtech/hhg-components/mantine'
 */
function DateRangePicker({ inputSize = 'md', name = 'date-range-picker', value, minDate, maxDate, onChange, className, autoClose = false, }) {
    if (!value) {
        value = { from: null, to: null };
    }
    const [opened, setOpened] = useState(false);
    function close() {
        setOpened(false);
    }
    const ref = useRef(null);
    useOutsideClick(ref, () => {
        close();
    });
    function handleChange(nextValue) {
        if (onChange) {
            onChange(nextValue);
        }
    }
    function formatDate(d) {
        return format(d, 'dd/MM/yyyy');
    }
    const fieldValue = useMemo(() => {
        if (value.from && value.to) {
            if (isSameDay(value.from, value.to)) {
                return formatDate(value.from);
            }
            return `${formatDate(value.from)} - ${formatDate(value.to)}`;
        }
        return '';
    }, [value.from, value.to]);
    function renderCalendar() {
        return (React__default.createElement(DateRangePickerCalendar, { value: value, onChange: handleChange, minDate: minDate, maxDate: maxDate, close: close, autoClose: autoClose }));
    }
    return (React__default.createElement(StyledWrapper, { className: [className, opened && 'focused'].filter(Boolean).join(' '), ref: ref },
        React__default.createElement("label", { htmlFor: name },
            React__default.createElement(PureInput, { size: inputSize, value: fieldValue, name: name, actionIcon: React__default.createElement("img", { src: CommonGAssets.getAssetPath('calendar.svg'), loading: "lazy" }), onFocus: () => setOpened(true) })),
        opened ? (React__default.createElement(StyledCalendarWrapper, { onMouseDown: (e) => {
                e.stopPropagation();
            } }, renderCalendar())) : null));
}

var styles = {"breadcrumb":"WUqzfRb","separator":"MnVGtSY","textLink":"NclbhXQ"};

const BreadcrumbItem = ({ LinkComponent, page, isLast, onChangePage, }) => {
    const { label, value, isDropdown, dropdownItems, dataEventCategory, dataEventAction, dataEventLabel, } = page;
    if (isDropdown) {
        return (React__default.createElement(Dropdown, { options: dropdownItems, placeholder: "...", id: "", placeholderIcon: null, onChange: onChangePage, className: "collapsed-breadcrumb" }));
    }
    return (React__default.createElement("div", { className: styles.textLink, title: typeof label !== 'string' ? value : label, "data-last": isLast }, LinkComponent && (React__default.createElement(LinkComponent, { "data-event-category": dataEventCategory, "data-event-action": dataEventAction, "data-event-label": dataEventLabel, href: value || '#' }, label))));
};
/**
 * @deprecated
 */
const Breadcrumbs = ({ className, pages, size, LinkComponent = 'a', onChangePage, separator, }) => {
    const mappedList = useMemo(() => pages
        .map((item, index) => {
        if (pages.length > 4) {
            if (index > 1 && index < pages.length - 2)
                return null;
            if (index === 1) {
                return Object.assign(Object.assign({}, item), { isDropdown: index === 1, dropdownItems: pages.slice(1, pages.length - 2) });
            }
            return item;
        }
        return item;
    })
        .filter(Boolean), [pages]);
    return (React__default.createElement("div", { "data-size": size, className: `${styles.breadcrumb} ${className || ''}` }, mappedList.map((page, index) => {
        const isLast = index + 1 === mappedList.length;
        return (React__default.createElement(Fragment, { key: index },
            React__default.createElement(BreadcrumbItem, { LinkComponent: LinkComponent, page: page, isLast: isLast, onChangePage: onChangePage }),
            !isLast &&
                (page.separator || separator || (React__default.createElement("div", { className: styles.separator, "data-size": size })))));
    })));
};

const StyledShareContainer = styled.div `
  display: flex;
  gap: 20px;
  width: 100%;
  align-items: center;
  justify-content: center;
  .icon-group {
    display: flex;
    align-items: center;
    gap: 10px;
    a,
    svg {
      width: 32px;
      height: 32px;
    }
    .share {
      width: 32px;
      height: 32px;
      padding: 8px;

      &:hover {
        background-color: ${theme.colors.neutral50};
      }

      svg {
        margin: 0;
        width: 16px;
        height: 16px;
      }
    }
  }
`;

const AttachIcon = () => {
    return (React__default.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none" },
        React__default.createElement("path", { d: "M6.86364 10.6666H5.22727C4.86912 10.6666 4.51448 10.5977 4.18359 10.4637C3.8527 10.3296 3.55205 10.1332 3.2988 9.8856C2.78734 9.3855 2.5 8.70722 2.5 7.99998C2.5 7.29274 2.78734 6.61446 3.2988 6.11436C3.81026 5.61426 4.50396 5.33331 5.22727 5.33331H6.86364M9.78374 5.33331H11.7727C12.1309 5.33331 12.4855 5.40229 12.8164 5.5363C13.1473 5.67031 13.4479 5.86674 13.7012 6.11436C13.9545 6.36198 14.1553 6.65596 14.2924 6.97949C14.4295 7.30303 14.5 7.64979 14.5 7.99998C14.5 8.35017 14.4295 8.69693 14.2924 9.02047C14.1553 9.344 13.9545 9.63798 13.7012 9.8856C13.4479 10.1332 13.1473 10.3296 12.8164 10.4637C12.4855 10.5977 12.1309 10.6666 11.7727 10.6666H9.78374", stroke: "#595959", strokeLinecap: "round", strokeLinejoin: "round" }),
        React__default.createElement("path", { d: "M6.5 8H10.5", stroke: "#595959", strokeLinecap: "round", strokeLinejoin: "round" })));
};
const ShareContainer = ({ url, onCopied, locale, siteType, }) => {
    const { t } = useTranslations();
    const socialList = getSocialList({ shareUrl: url || '', locale }).filter((s) => !s.allowedLocales || s.allowedLocales.includes(locale));
    const copyToClipboard = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        yield ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText(url));
        onCopied === null || onCopied === void 0 ? void 0 : onCopied();
    });
    const currentUrl = useMemo(() => {
        if (typeof window !== 'undefined') {
            return window.location.href;
        }
        else
            return '';
    }, []);
    return (React__default.createElement(StyledShareContainer, null,
        React__default.createElement(Text, { size: "p3", color: theme.colors.gray800 }, t('shareContainer.title')),
        React__default.createElement("div", { className: "icon-group" },
            socialList.map((social, index) => (React__default.createElement("a", { key: index, href: social.href, target: "_blank", rel: "noreferrer", "data-event-category": "Health Tool", "data-event-action": `Social Share - ${social.name}`, "data-event-label": currentUrl }, social.icon))),
            React__default.createElement(Button, { theme: siteType, size: "sm", type: "button", color: "tertiary", className: "share", style: {}, icon: React__default.createElement(AttachIcon, null), onClick: copyToClipboard, "data-event-category": "Health Tool", "data-event-action": "Copy Link", "data-event-label": currentUrl }))));
};

const StyledShareDrawer = styled(Drawer) `
  padding-bottom: 24px;
  .share-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .icon-group {
    margin-top: 12px;
    display: flex;
    gap: 16px;
    img {
      border-radius: 8px;
    }
  }
  .input-group {
    margin-top: 8px;
    display: flex;
    gap: 8px;
    button {
      padding: 10px;
      &:hover {
        background-color: ${theme.colors.neutral50};
      }
    }
    svg {
      margin: 0;
    }
    a,
    svg:not(.copy) {
      width: 32px;
      height: 32px;
    }
  }
`;

const CopyIcon = () => {
    return (React__default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", className: "copy" },
        React__default.createElement("path", { d: "M4 2.5C3.17125 2.5 2.5 3.17125 2.5 4V13.75C2.5 14.164 2.836 14.5 3.25 14.5C3.664 14.5 4 14.164 4 13.75V4H13.75C14.164 4 14.5 3.664 14.5 3.25C14.5 2.836 14.164 2.5 13.75 2.5H4ZM7 5.5C6.17125 5.5 5.5 6.17125 5.5 7V16C5.5 16.8287 6.17125 17.5 7 17.5H16C16.8287 17.5 17.5 16.8287 17.5 16V7C17.5 6.17125 16.8287 5.5 16 5.5H7ZM7 7H16V16H7V7Z", fill: "#595959" })));
};
const ShareDrawer = (_a) => {
    var { open, title, onClose, onCopied, onShared, url, locale } = _a, rest = __rest(_a, ["open", "title", "onClose", "onCopied", "onShared", "url", "locale"]);
    const { t } = useTranslations();
    const copyToClipboard = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        yield ((_b = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _b === void 0 ? void 0 : _b.writeText(url));
        onCopied === null || onCopied === void 0 ? void 0 : onCopied();
    }), [url, onCopied]);
    const socialList = getSocialList({ shareUrl: url || '', locale }).filter((platform) => !platform.allowedLocales || platform.allowedLocales.includes(locale));
    useEffect(() => {
        if (open && navigator.share) {
            navigator
                .share({
                title: title !== null && title !== void 0 ? title : 'Read This Post',
                url,
            })
                .then(() => {
                onShared === null || onShared === void 0 ? void 0 : onShared();
            })
                .catch(() => {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            });
        }
    }, [url, title, onShared, open]);
    if (typeof navigator !== 'undefined' && navigator.share) {
        return null;
    }
    else {
        return (React__default.createElement(StyledShareDrawer, Object.assign({ title: t('share.title'), onClose: onClose, open: open, placement: "bottom" }, rest),
            React__default.createElement("div", { className: "share-container" },
                React__default.createElement("div", { className: "icon-container" },
                    React__default.createElement(Text, { weight: "semiBold", size: "s3", color: theme.colors.gray600 }, t('share.title')),
                    React__default.createElement("div", { className: "icon-group" }, socialList.map((social, index) => (React__default.createElement("a", { key: index, href: social.href, target: "_blank", rel: "noreferrer" }, social.icon))))),
                React__default.createElement("div", { className: "link-container" },
                    React__default.createElement(Text, { weight: "semiBold", size: "s3", color: theme.colors.gray600 }, t('share.copyLink')),
                    React__default.createElement("div", { className: "input-group" },
                        React__default.createElement(Input, { name: "link", size: "md", value: url, isDisabled: true }),
                        React__default.createElement(Button, { size: "md", type: "button", color: "tertiary", icon: React__default.createElement(CopyIcon, null), onClick: copyToClipboard }))))));
    }
};

const StyledFixedAdBlock = styled.div `
  position: fixed;
  z-index: 48;
  bottom: 0;
  left: 50%;
  width: fit-content;
  max-width: 100%;
  background: none;
  transform: translateX(-50%);
  .close-sticky-button {
    position: absolute;
    display: flex;
    width: 16px;
    height: 16px;
    align-items: center;
    justify-content: center;
    background: #bfbfbf;
    border-radius: 50%;
    color: white;

    cursor: pointer;
    font-size: 12px;
    line-height: 12px;
    transform: translate(50%, -50%);
    top: 0;
    right: 0;
  }
  opacity: 0;
  pointer-events: none;
  &[data-visible='true'] {
    opacity: 1;
    pointer-events: auto;
  }
`;
const StyledAdContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 100%;
  width: fit-content;
  height: fit-content;
  margin-inline: auto;
  /* margin: 1rem auto; */
  &[data-no-wrapper='false'] {
    border: 1px solid ${theme.colors.neutral50};
    background: ${theme.colors.neutral50};
  }
  &[data-no-wrapper='true'] {
    line-height: 0;
  }
  &[data-header-bottom='true'] {
    flex-direction: column-reverse;
    background: none;
    border: none;
  }
`;
/* background: ${theme.colors.neutral50}; */
const StyledAdHeader = styled.div `
  width: 100%;
  padding: 0 5px 1.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  text-transform: capitalize;
  img {
    height: 12px;
    width: 12px;
    max-width: 12px;
    max-height: 12px;
  }
  &[data-header-bottom='true'] {
    background: ${theme.colors.neutral50};
  }
  span {
    font-size: 10px;
    line-height: 12px;
    color: ${theme.colors.gray400};
    font-weight: 400;
  }
`;
const StyledCloseBtn = styled.div `
  background-color: white;
  background-image: url(${CommonGAssets.getAssetPath('close-blue.svg')});
  background-repeat: no-repeat;
  background-size: 10px;
  background-position: center;
  width: 12px;
  height: 12px;
  position: absolute;
  top: 1px;
  right: 1px;
  cursor: pointer;
`;

const SlotsById = {};
const displayAd = ({ contentId, adUnitPath, size, divId, pos, sizeMapping, hideIfHasSubot, customTargetings, onSuccess, }) => {
    if (!divId || !document.getElementById(divId))
        return console.error('divId is required');
    destroyAdSlot(divId);
    window.googletag = window.googletag || { cmd: [] };
    const { googletag } = window;
    googletag.cmd.push(function () {
        const $content_id_container = document.querySelector('meta[name="content_id"]');
        const $content_id = typeof contentId === 'string' ? contentId : $content_id_container === null || $content_id_container === void 0 ? void 0 : $content_id_container.content;
        const newSlot = googletag.defineSlot(adUnitPath, size, divId);
        if (newSlot) {
            try {
                if (customTargetings) {
                    Object.keys(customTargetings).forEach((k) => {
                        if (k)
                            newSlot === null || newSlot === void 0 ? void 0 : newSlot.setTargeting(k, customTargetings[k]);
                    });
                }
            }
            catch (e) {
                console.error(e);
            }
            SlotsById[divId] = newSlot;
            newSlot.setTargeting('Pos', pos);
            newSlot.addService(googletag.pubads());
            if ($content_id)
                newSlot.setTargeting('Content_ID', $content_id);
            if (sizeMapping)
                newSlot.defineSizeMapping(sizeMapping);
            if (hideIfHasSubot && document.getElementById('subot--container')) {
                newSlot.setTargeting('chatbot', true);
            }
            googletag.display(divId);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        }
    });
};
const destroyAdSlot = (divId) => {
    if (SlotsById[divId]) {
        window.googletag = window.googletag || { cmd: [] };
        const { googletag } = window;
        googletag.cmd.push(function () {
            googletag.destroySlots([SlotsById[divId]]);
            delete SlotsById[divId];
        });
    }
};
const DEFAULT_30S_AD_POS = [
    'TopBanner',
    'MidBanner1',
    'MidBanner2',
    'EndBanner',
    'Sticky',
];
const ForwaredAdBlock = forwardRef(function InfinityAdBlock({ className, adUnitPath, size, divId, pos, sizeMapping, contentId, isHidden, hideIfHasSubot, isSticky, refreshInterval, // seconds
customTargetings, style, adDefaultSize, noWrapper, showCloseBtn, onCloseAd, headerBottom, wrapperProps, locale, isMarryBaby, }, ref) {
    const defaultRefreshInterval = refreshInterval ||
        (locale === LOCALE.Vietnam
            ? pos.some((p) => DEFAULT_30S_AD_POS.includes(p))
                ? 30
                : undefined
            : undefined);
    const { t } = useTranslations();
    const containerRef = useRef(null);
    const adRefreshIntervalRef = useRef(null);
    const refreshIntervalRef = useRef(defaultRefreshInterval);
    refreshIntervalRef.current = defaultRefreshInterval;
    const [localCloseAd, setLocalCloseAd] = useState(false);
    const adSlotChanged = () => {
        if (refreshIntervalRef.current) {
            if (adRefreshIntervalRef.current !== null) {
                clearInterval(adRefreshIntervalRef.current);
            }
            adRefreshIntervalRef.current = window.setInterval(() => {
                window.googletag = window.googletag || { cmd: [] };
                const { googletag } = window;
                googletag.cmd.push(function () {
                    if (SlotsById[divId]) {
                        googletag.pubads().refresh([SlotsById[divId]]);
                    }
                });
            }, refreshIntervalRef.current * 1000);
        }
    };
    useEffect(() => {
        return () => {
            destroyAdSlot(divId);
            if (adRefreshIntervalRef.current)
                clearInterval(adRefreshIntervalRef.current);
        };
    }, []);
    useEffect(() => {
        adSlotChanged();
    }, [defaultRefreshInterval]);
    useEffect(() => {
        if (!isHidden) {
            displayAd({
                contentId,
                adUnitPath,
                size,
                divId,
                pos,
                sizeMapping,
                hideIfHasSubot,
                customTargetings,
                onSuccess: adSlotChanged,
            });
        }
    }, [isHidden]);
    if (localCloseAd)
        return null;
    const AdContent = (React__default.createElement("div", { style: {
            position: 'relative',
            width: 'fit-content',
            height: 'fit-content',
            overflow: 'hidden',
            maxWidth: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        } },
        React__default.createElement("div", { ref: ref, id: divId }),
        showCloseBtn && (React__default.createElement(StyledCloseBtn, { onClick: () => {
                onCloseAd === null || onCloseAd === void 0 ? void 0 : onCloseAd();
                setLocalCloseAd(true);
            } }))));
    if (isSticky)
        return AdContent;
    const minWidth = adDefaultSize
        ? adDefaultSize[0]
        : size
            ? Array.isArray(size[0])
                ? size[0][0]
                : size[0]
            : undefined;
    const minHeight = adDefaultSize
        ? adDefaultSize[1]
        : size
            ? Array.isArray(size[0])
                ? size[0][1]
                : size[1]
            : undefined;
    return (React__default.createElement(Box, Object.assign({}, wrapperProps, { className: className }),
        React__default.createElement(StyledAdContainer, { ref: containerRef, className: className, style: style, "data-no-wrapper": !!noWrapper, "data-header-bottom": !!headerBottom }, noWrapper ? (AdContent) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(StyledAdHeader, { "data-header-bottom": !!headerBottom },
                React__default.createElement("img", { src: isMarryBaby
                        ? CommonGAssets.getAssetPath('adsIcon-mb.svg')
                        : CommonGAssets.getAssetPath('adsIcon.svg'), alt: "", loading: "lazy" }),
                React__default.createElement("span", null, t('adBanner.title'))),
            React__default.createElement("div", { style: {
                    minWidth: minWidth || '100%',
                    minHeight: minHeight || '100%',
                    position: 'relative',
                } }, AdContent))))));
});
const AdBlock = memo(ForwaredAdBlock, (prevProps, nextProps) => {
    return (prevProps.adUnitPath === nextProps.adUnitPath &&
        prevProps.divId === nextProps.divId &&
        prevProps.className === nextProps.className);
});

const FixedBottomAdBlock = ({ className, adUnitPath, divId, isMobile, contentId, customTargetings, locale, isMarryBaby, }) => {
    const [hideAd, setHideAd] = useState(true);
    const [userHideAd, setUserHideAd] = useState(false);
    const [hidden, setHidden] = useState(true);
    const adRef = useRef(null);
    const mountRandRef = useRef(v4());
    const fixedAdRef = useRef(null);
    const timeoutRef = useRef();
    const closeBtnTimeoutRef = useRef();
    useEffect(() => {
        const checkAdShowing = () => {
            if (closeBtnTimeoutRef.current)
                clearTimeout(closeBtnTimeoutRef.current);
            closeBtnTimeoutRef.current = setTimeout(() => {
                var _a;
                if (document.getElementById('subot--container')) {
                    setHideAd(true);
                }
                else {
                    setHideAd(false);
                    if (!((_a = adRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight)) {
                        setHidden(true);
                    }
                    else {
                        setHidden(false);
                    }
                }
                checkAdShowing();
            }, 4000);
        };
        checkAdShowing();
        return () => {
            timeoutRef.current && clearTimeout(timeoutRef.current);
            closeBtnTimeoutRef.current && clearTimeout(closeBtnTimeoutRef.current);
        };
    }, []);
    if (hideAd || userHideAd)
        return null;
    return (React__default.createElement(StyledFixedAdBlock, { key: isMobile ? 'mobile' : 'desktop', ref: fixedAdRef, className: className, "data-visible": !hidden }, adUnitPath && (React__default.createElement(AdBlock, { wrapperProps: { m: 0 }, ref: adRef, adUnitPath: adUnitPath, size: isMobile
            ? [
                [320, 50],
                [320, 100],
            ]
            : [728, 90], divId: (divId || 'div-gpt-ad-sticky') +
            (isMobile ? '-mobile' : '') +
            contentId +
            String(mountRandRef.current), pos: ['Sticky'], contentId: contentId, hideIfHasSubot: isMobile, customTargetings: customTargetings, adDefaultSize: isMobile ? [320, 50] : [728, 90], showCloseBtn: true, onCloseAd: () => setUserHideAd(true), refreshInterval: 60, locale: locale, isMarryBaby: isMarryBaby }))));
};

const StyleContainer = styled.div `
  padding: 20px;
  border-radius: 8px;
  background-image: url("data:image/svg+xml,%3Csvg width='1600' height='1024' viewBox='0 0 1600 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg filter='url(%23filter0_f_158_52300)'%3E%3Ccircle cx='889' cy='38' r='217' fill='%23BCDEFF'/%3E%3C/g%3E%3Cg filter='url(%23filter1_f_158_52300)'%3E%3Ccircle cx='402' cy='-38' r='402' fill='%23E3F2FF'/%3E%3C/g%3E%3Cg filter='url(%23filter2_f_158_52300)'%3E%3Ccircle cx='1147.5' cy='-38.5' r='180.5' fill='%23B3EED5'/%3E%3C/g%3E%3Cdefs%3E%3Cfilter id='filter0_f_158_52300' x='472' y='-379' width='834' height='834' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='100' result='effect1_foregroundBlur_158_52300'/%3E%3C/filter%3E%3Cfilter id='filter1_f_158_52300' x='-300' y='-740' width='1404' height='1404' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_158_52300'/%3E%3C/filter%3E%3Cfilter id='filter2_f_158_52300' x='767' y='-419' width='761' height='761' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='100' result='effect1_foregroundBlur_158_52300'/%3E%3C/filter%3E%3C/defs%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-position: top;

  ${MediaQueries.mbDown} {
    padding: 16px;
  }
`;
const StyleHeader = styled.div `
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  position: relative;
  .header-title {
    color: ${theme.colors.gray800};
    font-size: 18px;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.4px;
    width: calc(100% - 60px);

    svg {
      position: absolute;
    }

    ${MediaQueries.mbDown} {
      font-size: 16px;
      line-height: 24px;
    }
  }
  .header-site {
    background: linear-gradient(
      257deg,
      #12bfd6 19.24%,
      #2d87f3 47.1%,
      #262626 78.95%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-right: 20px;
  }
  .header-avatar {
    position: absolute;
    right: -40px;
    top: -52px;
  }
`;
const StyleQuestionSuggested = styled.div `
  display: flex;
  gap: 9px;
  flex-direction: column;
`;
const StyleQuestion = styled.div `
  display: flex;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.white};
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;

  ${MediaQueries.mbDown} {
    padding: 8px 10px;
  }

  .question-text {
    color: ${theme.colors.gray800};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;

    ${MediaQueries.mbDown} {
      font-size: 14px;
      line-height: 22px;
    }
  }

  svg {
    margin-top: 3px;
  }
`;
const StyleInputQuestion = styled.div `
  position: relative;
  margin-top: 20px;
  ${MediaQueries.mbDown} {
    margin-top: 8px;
  }
  .submitBtn {
    width: 36px;
    height: 36px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    .mantine-Button-leftIcon {
      margin: 0;
    }
  }
  .rightSection {
    position: absolute;
    top: 4px;
    right: 4px;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    border-radius: 100%;
    background-color: ${theme.colors.neutral100};
  }
`;
const StyleInput = styled.input `
  width: 100%;
  height: 44px;
  padding: 4px 4px 4px 24px;
  border-radius: 48px;
  border-radius: 48px;
  border: 1px solid #79e4dc;
  background: ${theme.colors.white};
  box-shadow: 0px 4px 12px 0px rgba(136, 205, 254, 0.24);
  &:focus {
    box-shadow: 0px 0px 0px 2px #91caff;
    border-color: #2d87f3;
  }
`;

var assets = [
	{
		h: 240,
		id: "0",
		p: "data:image/png;base64,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",
		u: "",
		w: 240,
		e: 1
	},
	{
		h: 560,
		id: "1",
		p: "data:image/png;base64,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",
		u: "",
		w: 560,
		e: 1
	},
	{
		id: "7",
		layers: [
			{
				ind: 6,
				ty: 2,
				parent: 5,
				ks: {
					s: {
						a: 0,
						k: [
							250,
							250
						]
					}
				},
				ip: 0,
				op: 181,
				st: 0,
				refId: "0"
			},
			{
				ind: 5,
				ty: 3,
				ks: {
					s: {
						a: 0,
						k: [
							13.33,
							13.33
						]
					}
				},
				ip: 0,
				op: 181,
				st: 0
			}
		]
	},
	{
		id: "11",
		layers: [
			{
				ind: 10,
				ty: 4,
				ks: {
				},
				ip: 0,
				op: 181,
				st: 0,
				shapes: [
					{
						ty: "rc",
						p: {
							a: 0,
							k: [
								52,
								52
							]
						},
						r: {
							a: 0,
							k: 0
						},
						s: {
							a: 0,
							k: [
								104,
								104
							]
						}
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								0
							]
						},
						o: {
							a: 0,
							k: 0
						}
					}
				]
			},
			{
				ind: 0,
				ty: 4,
				ks: {
					s: {
						a: 0,
						k: [
							133.33,
							133.33
						]
					}
				},
				ip: 0,
				op: 181,
				st: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ty: "sh",
										ks: {
											a: 0,
											k: {
												c: false,
												i: [
													[
														0,
														0
													],
													[
														28.44,
														0
													],
													[
														0,
														28.44
													],
													[
														-28.44,
														0
													],
													[
														0,
														-28.44
													]
												],
												o: [
													[
														0,
														28.44
													],
													[
														-28.44,
														0
													],
													[
														0,
														-28.44
													],
													[
														28.44,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														103.5,
														52
													],
													[
														52,
														103.5
													],
													[
														0.5,
														52
													],
													[
														52,
														0.5
													],
													[
														103.5,
														52
													]
												]
											}
										}
									},
									{
										ty: "gs",
										o: {
											a: 0,
											k: 100
										},
										e: {
											a: 0,
											k: [
												52,
												104
											]
										},
										g: {
											p: 2,
											k: {
												a: 0,
												k: [
													0,
													1,
													1,
													1,
													1,
													1,
													1,
													1,
													0,
													0.48,
													1,
													0
												]
											}
										},
										t: 1,
										a: {
											a: 0,
											k: 0
										},
										h: {
											a: 0,
											k: 0
										},
										s: {
											a: 0,
											k: [
												52,
												0
											]
										},
										lc: 1,
										lj: 1,
										ml: 4,
										w: {
											a: 0,
											k: 1
										}
									},
									{
										ty: "tr",
										o: {
											a: 0,
											k: 100
										},
										s: {
											a: 0,
											k: [
												75,
												75
											]
										}
									}
								]
							},
							{
								ty: "tr",
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				]
			}
		]
	},
	{
		id: "14",
		layers: [
			{
				ind: 13,
				ty: 0,
				ks: {
				},
				w: 104,
				h: 104,
				ip: 0,
				op: 181,
				st: 0,
				refId: "11"
			}
		]
	},
	{
		id: "18",
		layers: [
			{
				ind: 17,
				ty: 4,
				ks: {
				},
				ip: 0,
				op: 181,
				st: 0,
				shapes: [
					{
						ty: "el",
						p: {
							a: 0,
							k: [
								52,
								52
							]
						},
						s: {
							a: 0,
							k: [
								104,
								104
							]
						}
					},
					{
						ty: "gf",
						e: {
							a: 0,
							k: [
								52,
								104
							]
						},
						g: {
							p: 2,
							k: {
								a: 0,
								k: [
									0,
									1,
									1,
									1,
									1,
									1,
									1,
									1,
									0,
									1,
									1,
									0
								]
							}
						},
						t: 1,
						o: {
							a: 0,
							k: 100
						},
						s: {
							a: 0,
							k: [
								52,
								0
							]
						}
					}
				]
			}
		]
	},
	{
		id: "22",
		layers: [
			{
				ind: 21,
				ty: 4,
				ks: {
				},
				ip: 0,
				op: 181,
				st: 0,
				shapes: [
					{
						ty: "rc",
						p: {
							a: 0,
							k: [
								72,
								72
							]
						},
						r: {
							a: 0,
							k: 0
						},
						s: {
							a: 0,
							k: [
								144,
								144
							]
						}
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								0,
								0,
								0
							]
						},
						o: {
							a: 0,
							k: 0
						}
					}
				]
			},
			{
				ind: 0,
				ty: 4,
				ks: {
					s: {
						a: 0,
						k: [
							133.33,
							133.33
						]
					}
				},
				ip: 0,
				op: 181,
				st: 0,
				shapes: [
					{
						ty: "gr",
						it: [
							{
								ty: "gr",
								it: [
									{
										ty: "sh",
										ks: {
											a: 0,
											k: {
												c: false,
												i: [
													[
														0,
														0
													],
													[
														39.49,
														0
													],
													[
														0,
														39.49
													],
													[
														-39.49,
														0
													],
													[
														0,
														-39.49
													]
												],
												o: [
													[
														0,
														39.49
													],
													[
														-39.49,
														0
													],
													[
														0,
														-39.49
													],
													[
														39.49,
														0
													],
													[
														0,
														0
													]
												],
												v: [
													[
														143.5,
														72
													],
													[
														72,
														143.5
													],
													[
														0.5,
														72
													],
													[
														72,
														0.5
													],
													[
														143.5,
														72
													]
												]
											}
										}
									},
									{
										ty: "gs",
										o: {
											a: 0,
											k: 100
										},
										e: {
											a: 0,
											k: [
												72,
												144
											]
										},
										g: {
											p: 2,
											k: {
												a: 0,
												k: [
													0,
													1,
													1,
													1,
													1,
													1,
													1,
													1,
													0,
													0.2,
													1,
													0
												]
											}
										},
										t: 1,
										a: {
											a: 0,
											k: 0
										},
										h: {
											a: 0,
											k: 0
										},
										s: {
											a: 0,
											k: [
												72,
												0
											]
										},
										lc: 1,
										lj: 1,
										ml: 4,
										w: {
											a: 0,
											k: 1
										}
									},
									{
										ty: "tr",
										o: {
											a: 0,
											k: 100
										},
										s: {
											a: 0,
											k: [
												75,
												75
											]
										}
									}
								]
							},
							{
								ty: "tr",
								o: {
									a: 0,
									k: 100
								}
							}
						]
					}
				]
			}
		]
	},
	{
		id: "25",
		layers: [
			{
				ind: 24,
				ty: 0,
				ks: {
				},
				w: 144,
				h: 144,
				ip: 0,
				op: 181,
				st: 0,
				refId: "22"
			}
		]
	},
	{
		id: "29",
		layers: [
			{
				ind: 28,
				ty: 4,
				ks: {
				},
				ip: 0,
				op: 181,
				st: 0,
				shapes: [
					{
						ty: "el",
						p: {
							a: 0,
							k: [
								72,
								72
							]
						},
						s: {
							a: 0,
							k: [
								144,
								144
							]
						}
					},
					{
						ty: "gf",
						e: {
							a: 0,
							k: [
								72,
								144
							]
						},
						g: {
							p: 2,
							k: {
								a: 0,
								k: [
									0,
									1,
									1,
									1,
									1,
									1,
									1,
									1,
									0,
									1,
									1,
									0
								]
							}
						},
						t: 1,
						o: {
							a: 0,
							k: 100
						},
						s: {
							a: 0,
							k: [
								72,
								0
							]
						}
					}
				]
			}
		]
	},
	{
		id: "35",
		layers: [
			{
				ind: 34,
				ty: 2,
				parent: 33,
				ks: {
				},
				ip: 0,
				op: 181,
				st: 0,
				refId: "1"
			},
			{
				ind: 33,
				ty: 3,
				ks: {
					s: {
						a: 0,
						k: [
							50,
							50
						]
					}
				},
				ip: 0,
				op: 181,
				st: 0
			}
		]
	}
];
var fr = 60;
var h = 280;
var ip = 0;
var layers = [
	{
		ind: 9,
		ty: 0,
		parent: 4,
		ks: {
		},
		w: 80,
		h: 80,
		ip: 0,
		op: 181,
		st: 0,
		refId: "7"
	},
	{
		ind: 4,
		ty: 3,
		parent: 3,
		ks: {
			p: {
				a: 0,
				k: [
					100,
					100
				]
			}
		},
		ip: 0,
		op: 181,
		st: 0
	},
	{
		ind: 16,
		ty: 0,
		parent: 3,
		ks: {
			a: {
				a: 0,
				k: [
					52,
					52
				]
			},
			o: {
				a: 0,
				k: 48
			},
			p: {
				a: 0,
				k: [
					140,
					140
				]
			},
			r: {
				a: 1,
				k: [
					{
						t: 0,
						s: [
							0
						],
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						}
					},
					{
						t: 180,
						s: [
							360
						],
						h: 1
					}
				]
			}
		},
		w: 104,
		h: 104,
		ip: 0,
		op: 181,
		st: 0,
		refId: "14"
	},
	{
		ind: 20,
		ty: 0,
		parent: 3,
		ks: {
			a: {
				a: 0,
				k: [
					52,
					52
				]
			},
			o: {
				a: 0,
				k: 48
			},
			p: {
				a: 0,
				k: [
					140,
					140
				]
			},
			r: {
				a: 1,
				k: [
					{
						t: 0,
						s: [
							0
						],
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						}
					},
					{
						t: 180,
						s: [
							360
						],
						h: 1
					}
				]
			}
		},
		w: 104,
		h: 104,
		ip: 0,
		op: 181,
		st: 0,
		refId: "18"
	},
	{
		ind: 27,
		ty: 0,
		parent: 3,
		ks: {
			a: {
				a: 0,
				k: [
					72,
					72
				]
			},
			o: {
				a: 0,
				k: 20
			},
			p: {
				a: 0,
				k: [
					140,
					140
				]
			},
			r: {
				a: 1,
				k: [
					{
						t: 0,
						s: [
							0
						],
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						}
					},
					{
						t: 180,
						s: [
							-360
						],
						h: 1
					}
				]
			},
			s: {
				a: 1,
				k: [
					{
						t: 0,
						s: [
							100,
							100
						],
						i: {
							x: [
								0,
								0
							],
							y: [
								1,
								1
							]
						},
						o: {
							x: [
								0.5,
								0.5
							],
							y: [
								0,
								0
							]
						}
					},
					{
						t: 60,
						s: [
							90,
							90
						],
						i: {
							x: [
								1,
								1
							],
							y: [
								1,
								1
							]
						},
						o: {
							x: [
								0,
								0
							],
							y: [
								0,
								0
							]
						}
					},
					{
						t: 120,
						s: [
							90,
							90
						],
						i: {
							x: [
								0,
								0
							],
							y: [
								1,
								1
							]
						},
						o: {
							x: [
								0.5,
								0.5
							],
							y: [
								0,
								0
							]
						}
					},
					{
						t: 180,
						s: [
							100,
							100
						],
						h: 1
					}
				]
			}
		},
		w: 144,
		h: 144,
		ip: 0,
		op: 181,
		st: 0,
		refId: "25"
	},
	{
		ind: 31,
		ty: 0,
		parent: 3,
		ks: {
			a: {
				a: 0,
				k: [
					72,
					72
				]
			},
			o: {
				a: 0,
				k: 20
			},
			p: {
				a: 0,
				k: [
					140,
					140
				]
			},
			r: {
				a: 1,
				k: [
					{
						t: 0,
						s: [
							0
						],
						i: {
							x: 0,
							y: 1
						},
						o: {
							x: 0.5,
							y: 0
						}
					},
					{
						t: 180,
						s: [
							-360
						],
						h: 1
					}
				]
			},
			s: {
				a: 1,
				k: [
					{
						t: 0,
						s: [
							100,
							100
						],
						i: {
							x: [
								0,
								0
							],
							y: [
								1,
								1
							]
						},
						o: {
							x: [
								0.5,
								0.5
							],
							y: [
								0,
								0
							]
						}
					},
					{
						t: 60,
						s: [
							90,
							90
						],
						i: {
							x: [
								1,
								1
							],
							y: [
								1,
								1
							]
						},
						o: {
							x: [
								0,
								0
							],
							y: [
								0,
								0
							]
						}
					},
					{
						t: 120,
						s: [
							90,
							90
						],
						i: {
							x: [
								0,
								0
							],
							y: [
								1,
								1
							]
						},
						o: {
							x: [
								0.5,
								0.5
							],
							y: [
								0,
								0
							]
						}
					},
					{
						t: 180,
						s: [
							100,
							100
						],
						h: 1
					}
				]
			}
		},
		w: 144,
		h: 144,
		ip: 0,
		op: 181,
		st: 0,
		refId: "29"
	},
	{
		ind: 37,
		ty: 0,
		parent: 32,
		ks: {
		},
		w: 280,
		h: 280,
		ip: 0,
		op: 181,
		st: 0,
		refId: "35"
	},
	{
		ind: 32,
		ty: 3,
		parent: 3,
		ks: {
			a: {
				a: 0,
				k: [
					140,
					140
				]
			},
			p: {
				a: 0,
				k: [
					140,
					140
				]
			},
			r: {
				a: 1,
				k: [
					{
						t: 0,
						s: [
							0
						],
						i: {
							x: 1,
							y: 1
						},
						o: {
							x: 0,
							y: 0
						}
					},
					{
						t: 180,
						s: [
							15
						],
						h: 1
					}
				]
			},
			s: {
				a: 1,
				k: [
					{
						t: 0,
						s: [
							100,
							100
						],
						i: {
							x: [
								0,
								0
							],
							y: [
								1,
								1
							]
						},
						o: {
							x: [
								0.5,
								0.5
							],
							y: [
								0,
								0
							]
						}
					},
					{
						t: 60,
						s: [
							90,
							90
						],
						i: {
							x: [
								1,
								1
							],
							y: [
								1,
								1
							]
						},
						o: {
							x: [
								0,
								0
							],
							y: [
								0,
								0
							]
						}
					},
					{
						t: 120,
						s: [
							90,
							90
						],
						i: {
							x: [
								0,
								0
							],
							y: [
								1,
								1
							]
						},
						o: {
							x: [
								0.5,
								0.5
							],
							y: [
								0,
								0
							]
						}
					},
					{
						t: 180,
						s: [
							100,
							100
						],
						h: 1
					}
				]
			}
		},
		ip: 0,
		op: 181,
		st: 0
	},
	{
		ind: 3,
		ty: 3,
		parent: 2,
		ks: {
		},
		ip: 0,
		op: 181,
		st: 0
	},
	{
		ind: 2,
		ty: 3,
		ks: {
		},
		ip: 0,
		op: 181,
		st: 0
	}
];
var meta = {
	g: "https://jitter.video"
};
var op = 180;
var v = "5.7.4";
var w = 280;
var Avatar = {
	assets: assets,
	fr: fr,
	h: h,
	ip: ip,
	layers: layers,
	meta: meta,
	op: op,
	v: v,
	w: w
};

const WidgetChatbotAi = ({}) => {
    const [value, setValue] = useState('');
    const questionSuggested = [
        {
            id: '1',
            text: 'Should I go to a spa to get my acne squeezed?',
        },
        {
            id: '2',
            text: 'What should I do if my acne is red and swollen after squeezing it?',
        },
        {
            id: '3',
            text: 'Check your skin health',
        },
    ];
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!value)
            return;
        // Go to ai chatbot page
        const destinationPath = `https://demo.hellobacsi.com/ai-chatbot?question=${encodeURIComponent(value)}`;
        window.location.href = destinationPath;
    };
    const handleAskQuestion = (data) => {
        const destinationPath = `https://demo.hellobacsi.com/ai-chatbot?questionId=${data.id}&question=${encodeURIComponent(data.text)}`;
        window.location.href = destinationPath;
    };
    return (React__default.createElement(StyleContainer, null,
        React__default.createElement(StyleHeader, null,
            React__default.createElement("div", { className: "header-title" },
                "Ask any health concern! Our",
                React__default.createElement("span", { className: "header-site" },
                    "\u00A0AI health assistant ",
                    React__default.createElement(MultiStar, null),
                    " \u00A0"),
                "is here to help \u00A0"),
            React__default.createElement("div", { className: "header-avatar" },
                React__default.createElement(Lottie, { animationData: Avatar, style: {
                        width: 135,
                        height: 135,
                    }, loop: true }))),
        React__default.createElement(StyleQuestionSuggested, null, questionSuggested.map((item) => {
            return (React__default.createElement(StyleQuestion, { key: item.id, onClick: () => handleAskQuestion(item) },
                React__default.createElement(Question, null),
                React__default.createElement("div", { className: "question-text" }, item.text)));
        })),
        React__default.createElement(StyleInputQuestion, null,
            React__default.createElement("form", { onSubmit: handleSubmit },
                React__default.createElement(StyleInput, { type: "text", value: value, onChange: (e) => setValue(e.target.value), name: "input-message", placeholder: "Ask anything..." }),
                React__default.createElement(Box, { className: "rightSection" },
                    React__default.createElement(Button$1, { className: "submitBtn", type: "submit", variant: value ? 'primary' : 'ghost', leftIcon: React__default.createElement(ArrowRight, { size: 16, color: value ? '#fff' : '#595959' }) }))))));
};

export { AdBlock as A, Breadcrumbs as B, CategoryCard as C, DatePicker as D, FloatButtonGroup as F, IconText as I, RadioGroup as R, ScrollList as S, Tabs as T, WidgetChatbotAi as W, CheckboxGroup as a, StatisticCard as b, index as c, DoctorInfo as d, CookieAcceptConfirm as e, SeoHead as f, DateRangePicker as g, ShareContainer as h, index$1 as i, ShareDrawer as j, FixedBottomAdBlock as k };
